<template>
  <v-form> 
  <v-container fluid class="my-0 pa-2 forma-erp stavka-unos">
    <v-row no-gutters>
      <v-col cols="12">
            <v-row v-if="error">
              <v-alert 
                :type="typeError"
                v-model="alert"
                dismissible>
               {{error}}
              </v-alert>
            </v-row>
          <!-- Traka ekrana, ista kao na ostalim obrascima. Gumbi su u podnozju,
               koje je ionako uvijek vidljivo, pa se ovdje ne ponavljaju. -->
          <div class="traka-ekrana mb-3">
            <span class="naslov">{{ lang.NewItemLine }}</span>
            <span class="broj" v-if="$store.state.documentActivHead.documentId">
              {{ documentNameLoc }} {{ $store.state.documentActivHead.documentId }}
            </span>
            <span class="uz" v-if="$store.state.documentActivHead.partnerName">
              {{ $store.state.documentActivHead.partnerName }}
            </span>
          </div>
          <v-card
            class="pa-2 ma-1"
                outlined
              >
              <v-row no-gutters>
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12" class="gray">
                  <!-- Bez "pb-2" i "pb-3": donji razmak je bio 28px, gornji 8,
                       pa je kartica izgledala nakrivo. -->
                  <div class="text-h6">
                    <v-btn text color="primary" @click="optionsOn()" class="pl-0">Opcije za artikal/uslugu <v-icon v-if="!showOptions">mdi-chevron-down</v-icon><v-icon v-if="showOptions">mdi-chevron-up</v-icon></v-btn>
                  </div>
                </v-col>
              </v-row>
            <div v-if="showOptions">
              <v-row>
                  <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3">
                    <v-select
                      outlined hide-details="auto"
                        :items="privGroups"
                        v-model="selectGroup"
                        :label="lang.selectGroup"
                        single-line
                        item-text="GroupName"
                        item-value="id"
                        return-object
                        persistent-hint
                        clearable
                        dense
                      ></v-select>
                  </v-col>
                  <v-col cols="12" sm="9" md="9" xs="9" class="right">
                  <v-btn text small color="primary" @click="showGroup" class="mr-1">
                      {{lang.Items}}
                    </v-btn>
                    <v-btn text small color="primary" @click="warehouseState" class="mr-1">
                      {{lang.WarehouseState2}},{{$store.state.warehousemarkid}}
                    </v-btn>
                    <v-btn text small color="primary" @click="itemCard" class="mr-1">
                      {{lang.ItemCard}}
                    </v-btn>
                    <v-btn text small color="primary" @click="itemCardSell" class="mr-1">
                      {{lang.ItemCardInv}}
                    </v-btn>
                    <v-btn text small color="primary" @click="createNewItem" class="mr-1">
                      Novi artikal
                    </v-btn>
                    <v-btn text small color="red darken-1" @click="deleteDD2">
                      {{langC.Delete}}
                    </v-btn>
                  </v-col>
              </v-row>
            </div>
          </v-card>
          <!-- Lijevo ono sto se upisuje, desno ono sto program racuna. -->
          <v-row no-gutters>
            <v-col cols="12" lg="7" class="pr-lg-3">

          <v-card
            class="pa-2 ma-1"
                outlined
              >

              <v-card-title class="naslov-kartice">
                {{lang.ItemFor}}
                <v-spacer></v-spacer>
                <!-- Gumbi su prije stajali svaki u svom retku ispod polja i
                     trosili tri reda visine bez ijednog podatka. U traci
                     naslova su uvijek na istom mjestu, kao i na kartici
                     eRacun. -->
                <v-btn text small color="primary" class="pa-0 mr-3" @click="showItemCardd" v-if="haveItemSelected">
                  {{lang.showItemCardd}}
                </v-btn>
                <v-btn text small color="primary" class="pa-0 mr-3" @click="updateItemName" v-if="haveItemSelected">
                  {{lang.UpdateItem}}
                </v-btn>
                <v-btn text small color="primary" class="pa-0" @click="addDesc()" v-if="haveItemSelected">
                  <v-icon small>{{ showDesc ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  {{ lang.ItemMoreFields }}
                </v-btn>
              </v-card-title>
              <div class="pt-3"></div>

              <v-row dense align="start">
                <v-col cols="12">
                  <!-- Trazi se i po sifri i po nazivu: "itemByID" je
                       "sifra naziv cijena", pa upis naziva pogada jednako kao
                       upis sifre. Filtar je vlastiti jer Vuetifyjev zadani
                       trazi obican podniz, pa "secer" nije nalazio "ŠEĆER" -
                       a 42 % naziva u bazi ima kvacicu. "sveRijeci" uz to ne
                       mari za redoslijed, pa radi i "kit siliko" i "siliko kit". -->
                  <v-autocomplete
                      outlined dense hide-details="auto"
                    v-if="itemsLoc.length > 0"
                    :items="itemsLoc"
                    v-model="selectIL"
                    :label="lang.ItemSelect"
                    item-text="itemByID"
                    item-value="itemID"
                    :filter="sveRijeci"
                    clearable
                    return-object
                    class="pa-0 my-0"
                    :key="componentKey"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <!-- Naziv, mjera i grupa stoje u jednom retku, kao na mockupu.
                   Prije je svako polje bilo cols="12" pa je svako trosilo cijeli
                   red i kartica se rastezala bez potrebe. Grupa je izvucena iz
                   sklopive skupine jer se cita uz artikl, a ne uz opis. -->
              <v-row dense align="start">
                <v-col cols="12" md="6">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemName"
                      v-model="iName"
                    ></v-text-field>    
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemUnit"
                      v-model="iUnit"
                    ></v-text-field>    
                </v-col>
                <v-col cols="6" sm="8" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemGroup"
                      v-model="iGroupName"
                      disabled
                    ></v-text-field>
                </v-col>
              </v-row>
            
              <!-- pt-1 nadoknadjuje razmak koji se izgubi na rubu ovog
                   omotaca, inace prvi redak skupine dodiruje redak iznad. -->
              <div class="pt-1" v-if="showDesc">
              <v-row dense align="start">
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemNameShort"
                      v-model="iNameShort"
                    ></v-text-field>    
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemGroupCode"
                      v-model="iGroup"
                      type="number"
                      disabled
                    ></v-text-field>                   
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-checkbox
                    v-model="iForceNewPrintPage"
                    :label="lang.forceNewPrintPage"
                    class="pa-0 ma-0"
                    dense hide-details
                  ></v-checkbox>
                </v-col>
            </v-row>
            <v-row dense align="start">
                <v-col cols="12">
                  <v-textarea
                      outlined hide-details="auto"
                      dense
                      rows="3"
                      auto-grow
                      :label="lang.ItemDescription"
                      v-model="iDescription"
                    ></v-textarea>
                </v-col>
            </v-row>

            <v-row dense align="start">
               
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.FreeF3"
                      v-model.number="iSize"
                      type="number"
                    ></v-text-field>                   
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.FreeF4"
                      v-model.number="iFreeF4"
                      type="number"
                    ></v-text-field>                   
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemEANCode"
                      v-model="iEANCode"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemSerialNr"
                      v-model="iSerialNr"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <div v-if="showPT">
                      <v-autocomplete
                      outlined dense hide-details="auto"
                        :label="lang.MainLedgerProjectTypeName"
                        :items="projectTypes"
                        v-model="selectPT"
                        item-text="TypeName"
                        item-value="id"
                        return-object
                        @change="choosedProjectType(selectPT)"
                        clearable
                        ></v-autocomplete>
                    </div>
                </v-col>
            </v-row>
            </div>
          </v-card>

          <v-card
            class="pa-2 ma-1"
                outlined
              >

              <v-card-title class="naslov-kartice">Cijena</v-card-title>
              <div class="pt-3"></div>
            <!-- Ulazni dokument: prve dvije cijene su prije stajale svaka u
                 svom retku iako su uske. Uvjet je presao s retka na polje pa se
                 prikazuju ista polja kao i dosad, samo u istom redu. Maknut je
                 i "mr-1" - zbog tog 4px razmaka tri polja od md="4" nisu stala
                 u red pa je svaki red imao samo dva. -->
            <!-- Ulazni dokument (primka). Polja idu redom kojim se cijena i
                 gradi, slijeva nadesno:

                   cijena dobavljaca -> rabat % -> dobavna (umanjena za rabat)
                   -> marza % -> marza iznos -> cijena bez PDV-a
                   -> PDV % -> iznos PDV-a -> cijena s PDV-om

                 Otvorena su samo polja koja se upisuju; izracunata su
                 zakljucana, da se ne moze upisati nesto sto ce sljedeci racun
                 pregaziti. Olovka stoji uz zadnje polje: klikom se zatvori sve
                 ostalo i upisuje se samo konacna cijena s PDV-om, iz koje se
                 onda racuna marza unatrag. Dobavne cijene se pritom NE diraju.

                 "Cijena u valuti" se prikazuje samo na INO primci (uvoz izvan
                 EU) - iz nje se po tecaju racuna cijena dobavljaca u eurima,
                 pa je ta u tom slucaju zakljucana. -->
            <v-row dense align="start" v-if="this.$store.state.documentSide === 1">
                <v-col cols="12" sm="6" md="3">
                      <v-text-field
                      outlined hide-details="auto"
                        dense
                        :label="lang.ItemPcsPlus"
                        v-model.number="iPcsPlus"
                        type="number"
                      ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" v-if="exportDoc">
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.itemSuppBaseForePrice"
                      v-model.number="iSuppBaseForePrice"
                      type="number"
                      @input="cijenaRucno = false"
                      hint="INO primka — preračunava se u EUR po tečaju"
                      persistent-hint
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                      <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemSuppBasePrice"
                      v-model.number="iSuppBasePrice"
                      type="number"
                      @input="cijenaRucno = false"
                      :disabled="!fullpriceChange || exportDoc"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemSuppDiscount"
                      v-model.number="iSuppDiscount"
                      type="number"
                      @input="cijenaRucno = false"
                      :disabled="!fullpriceChange"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemSuppPrice"
                      :value="iSuppPrice"
                      type="number"
                      disabled
                    ></v-text-field>
                </v-col>

                <v-col cols="6" sm="3" md="2">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemMargin"
                      v-model.number="iMargin"
                      type="number"
                      @input="cijenaRucno = false"
                      :disabled="!fullpriceChange"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemMarginAmount"
                      :value="iFreeF2"
                      type="number"
                      disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPrice"
                      v-model.number="iPrice"
                      type="number"
                      :disabled="!fullpriceChange"
                      @input="cijenaRucno = true"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemVAT1Percentage"
                      :value="iVAT1Percentage"
                      type="number"
                      disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemVAT1Amount"
                      :value="iPdvPoKomadu"
                      type="number"
                      disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPriceWithVAT"
                      v-model.number="iPriceWithVAT"
                      type="number"
                      :disabled="fullpriceChange"
                      >
                      <template #append-outer>
                        <v-btn icon small @click="fullpriceSwitch"
                               :title="fullpriceChange ? 'Upiši konačnu cijenu s PDV-om' : 'Natrag na izračun iz marže'">
                          <v-icon small>{{ fullpriceChange ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <!-- Izlazni dokument (otpremnica, racun, ponuda...). Dva reda,
                 slozena tako da se cijena cita okomito:

                   1. dobavna cijena | kolicina | CIJENA EUR     | rabat %
                   2. usluga | naknada | CIJENA S PDV-om + olovka | PDV % | ukupno

                 "Cijena sa PDVom" stoji tocno ispod "Cijene EUR" - prvi stupac
                 drugog reda zato zauzima 5/12, koliko i dobavna i kolicina
                 zajedno. Naknada i PDV % su uski, to su mali brojevi.

                 Oba reda popunjavaju svih 12 stupaca, pa kartica nema praznine
                 na desnoj strani, i to na obje sirine ekrana:

                   md (>=960px)   1. red: 3 + 2 + 3 + 4 = 12   (5 + 3 + 4 bez dobavne)
                                  2. red: 3 + 2 + 3 + 2 + 2 = 12
                   sm (600-960)   1. red: 2 + 2 + 4 + 4 = 12   (4 + 4 + 4 bez dobavne)
                                  2. red: 2 + 2 + 4 + 2 + 2 = 12

                 Vazno je da je zbroj polja ISPRED cijene jednak u oba reda
                 (5 na md, 4 na sm) - inace "Cijena sa PDVom" ne stoji tocno
                 ispod "Cijene EUR". Rabat % je siri od ostalih malih polja jer
                 drugi red ima jedno polje vise, pa visak prvog reda ide njemu.

                 Olovka je "append" (unutar okvira), ne "append-outer": izvan
                 okvira je prelazila sirinu svog stupca i gurala kvacicu "Usl."
                 u treci red. -->
            <v-row dense align="start" v-if="this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3">
                <v-col cols="6" sm="2" md="3" v-if="!hidePurchase">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="langItemSuppPrice"
                      v-model.number="iSuppPrice"
                      type="number"
                    >
                      <!-- Provjera dobavne cijene bila je zaseban gumb u vlastitom
                           retku; kao ikona uz polje ne trosi stupac. -->
                      <template #append>
                        <v-btn icon small @click="checkSupplierPrice" title="Dob.Provjeri">
                          <v-icon small>mdi-magnify</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                    <!-- RUC i RUC% stavke. Namjerno bez naziva, sitno i blijedo:
                         podatak je za onoga tko radi, ne za onoga tko gleda
                         preko ramena. Naziv je u "title", na prijelaz misem. -->
                    <div class="ruc-tiho" v-if="iSuppPriceAmount" :title="lang.ItemMarginAmount + ' / ' + lang.ItemMargin">
                      {{ localMoney(iMarginAmount) }} &middot; {{ localMoney(iMargin) }} %
                    </div>
                </v-col>
                <v-col cols="6" :sm="hidePurchase ? 4 : 2" :md="hidePurchase ? 5 : 2">
                    <!-- Oznaka je prije bila "lang.itemPcsMinus" malim slovom, a
                         kljuc je "ItemPcsMinus" - polje je stajalo bez naziva.
                         Kad je dobavna cijena skrivena (pravo "Sakrij Dob."),
                         kolicina preuzme njezinu sirinu da red ostane pun i da
                         "Cijena EUR" i dalje pada na isto mjesto. -->
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPcsMinus"
                      v-model.number="iPcsMinus"
                      type="number"
                      v-if="this.$store.state.documentSide === 2"
                    ></v-text-field>
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPcsNeutral"
                      v-model.number="iPcsNeutral"
                      type="number"
                      v-if="this.$store.state.documentSide === 3"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="langItemPrice"
                      v-model.number="iPrice"
                      type="number"
                      v-if="this.showExport === false"
                      :disabled="!fullpriceChange"
                    ></v-text-field>
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="langItemPrice"
                      v-model.number="iForePrice"
                      type="number"
                      v-if="this.showExport === true"
                      :disabled="!fullpriceChange"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="4" md="4">
                      <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemDiscountPercentage1"
                      v-model.number="iDiscountPercentage1"
                      type="number"
                      :disabled="!fullpriceChange"
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row dense align="start" v-if="this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3">
                <!-- Sirina prati prvi red: ispred "Cijene EUR" uvijek stoji
                     isto - 5/12 na sirokom ekranu (dobavna 3 + kolicina 2, ili
                     samo kolicina 5 kad je dobavna skrivena), 4/12 na srednjem.
                     Bez toga "Cijena sa PDVom" ne pada tocno ispod "Cijene EUR". -->
                <v-col cols="12" sm="2" md="3">
                  <v-checkbox
                    v-model="iService"
                    :label="lang.Service"
                    class="pa-0 ma-0 mt-2"
                    dense hide-details
                  ></v-checkbox>
                </v-col>
                <!-- Direktna naknada stoji uz uslugu, lijevo od cijene. Nije
                     najlogicniji redoslijed, ali tako je dogovoreno - polje se
                     koristi rijetko pa ne smeta na pocetku reda. -->
                <v-col cols="4" sm="2" md="2">
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemDirectDuty1"
                      v-model.number="iDirectDuty1"
                      type="number"
                      v-if="this.showExport === false"
                    ></v-text-field>
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemDirectDuty1"
                      v-model.number="iForeDirectDuty1"
                      type="number"
                      v-if="this.showExport === true"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                      <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPriceWithVAT"
                      v-model.number="iPriceWithVAT"
                      type="number"
                      :disabled="fullpriceChange"
                      v-if="this.showExport === false"
                      >
                      <template #append>
                        <v-btn icon small @click="fullpriceSwitch"
                               :title="fullpriceChange ? 'Upiši konačnu cijenu s PDV-om' : 'Natrag na izračun iz cijene'">
                          <v-icon small>{{ fullpriceChange ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                     <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPriceWithVAT"
                      v-model.number="iForePriceWithVAT"
                      type="number"
                      :disabled="fullpriceChange"
                      v-if="this.showExport === true"
                      >
                      <template #append>
                        <v-btn icon small @click="fullpriceSwitch"
                               :title="fullpriceChange ? 'Upiši konačnu cijenu s PDV-om' : 'Natrag na izračun iz cijene'">
                          <v-icon small>{{ fullpriceChange ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                </v-col>
                <!-- Stopa PDV-a dolazi s artikla i ovdje se samo pokazuje.
                     Sirina mu je fiksna (razred "pdv-usko"), tek toliko da stane
                     naziv "PDV %" i dva broja - mreza od 12 stupaca je ovdje
                     pregruba: jedan stupac je preuzak za naziv, dva su presiroka.
                     Ostatak reda do kraja uzima "Ukupno". -->
                <v-col cols="4" sm="2" md="2" class="pdv-usko">
                      <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemVAT1Percentage"
                      v-model.number="iVAT1Percentage"
                      type="number"
                      disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="4" sm="2" md="2" class="ukupno-ostatak">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemTotal"
                      :value="localMoney(ukupnoSNaknadom)"
                      disabled
                      style="font-weight:bold"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense align="start" v-if="this.$store.state.documentSide === 1 && doRetail">
              <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPrice"
                      v-model.number="iPrice"
                      type="number"
                      disabled
                    ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                      <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemVAT1Percentage"
                      v-model.number="iVAT1Percentage"
                      type="number"
                      disabled
                    ></v-text-field>
              </v-col>                 
              <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPriceWithVAT"
                      v-model.number="iPriceWithVAT"
                      type="number"
                      :disabled="fullpriceChange"
                    
                      >
                      <template #append-outer>
                        <v-btn icon small @click="fullpriceSwitch"
                               :title="fullpriceChange ? 'Otključaj cijenu' : 'Zaključaj cijenu'">
                          <v-icon small>{{ fullpriceChange ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
               </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="langItemAmountWithVAT"
                      v-model.number="iAmountWithVAT"
                      type="number"
                      disabled
                      style="font-weight:bold"
                      v-if="this.showExport === false"
                    ></v-text-field>       
                </v-col>
            </v-row>
            <!-- Ono sto kupac placa za jedan komad, u jednom redu:
                 cijena s PDV-om + direktna naknada = ukupna cijena.
                 Naknada je uza jer je to uvijek mali iznos.
                 Izlazni dokumenti imaju vlastiti raspored iznad, pa ovaj red
                 ostaje samo za ulazni. -->
            <v-row dense align="start" v-if="this.$store.state.documentSide === 1">
                <v-col cols="12" sm="6" md="4" v-if="this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3">
                      <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPriceWithVAT"
                      v-model.number="iPriceWithVAT"
                      type="number"
                      :disabled="fullpriceChange"
                      v-if="this.showExport === false"
                    
                      >
                      <template #append-outer>
                        <v-btn icon small @click="fullpriceSwitch"
                               :title="fullpriceChange ? 'Otključaj cijenu' : 'Zaključaj cijenu'">
                          <v-icon small>{{ fullpriceChange ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                     <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPriceWithVAT"
                      v-model.number="iForePriceWithVAT"
                      type="number"
                      :disabled="fullpriceChange"
                      v-if="this.showExport === true"
                    
                      >
                      <template #append-outer>
                        <v-btn icon small @click="fullpriceSwitch"
                               :title="fullpriceChange ? 'Otključaj cijenu' : 'Zaključaj cijenu'">
                          <v-icon small>{{ fullpriceChange ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                </v-col>
                <!-- ml-md-auto: na ulaznom dokumentu stupac "Cijena sa PDVom"
                     je skriven pa ostaje 4/12 praznog mjesta. Automatska lijeva
                     margina gura ostatak udesno, da "Ukupna cijena" i dalje
                     zavrsava tocno ispod polja iz retka iznad. Na izlaznom
                     dokumentu stupci popunjavaju svih 12 pa margina nema sto
                     rasporediti i nista se ne mice. -->
                <v-col cols="6" sm="3" md="3" class="ml-md-auto">
                    <v-text-field
                      outlined hide-details="auto"
                    dense
                    :label="lang.ItemDirectDuty1"
                    v-model.number="iDirectDuty1"
                    type="number"
                    v-if="this.showExport === false"
                  ></v-text-field>
                  <v-text-field
                      outlined hide-details="auto"
                    dense
                    :label="lang.ItemDirectDuty1"
                    v-model.number="iForeDirectDuty1"
                    type="number"
                    v-if="this.showExport === true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-checkbox
                    v-model="iService"
                    :label="lang.Service"
                    class="pa-0 ma-0"
                    dense hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="6" sm="3" md="3">
                  <v-text-field
                      outlined hide-details="auto"
                      dense
                      :label="lang.ItemPriceWithDuty"
                      :value="localMoney(ukupnoSNaknadom)"
                      disabled
                    ></v-text-field>
                </v-col>
            </v-row>
            
          </v-card>
            </v-col>

            <v-col cols="12" lg="5">

          <!-- IZRACUN
               Popis onoga sto program racuna, umjesto niza onemogucenih polja.
               Polja su bila disabled pa se u njih ionako nije moglo tipkati -
               ovako se citaju odozgo prema dolje i zavrsavaju iznosom stavke.
               Vrijednosti su iste, iz istih podataka. -->
          <v-card outlined class="mb-3">
              <v-card-title class="naslov-kartice">
                Izračun <span class="dodatak">{{ lang.CalculatedHint }}</span>
              </v-card-title>
              <v-card-text class="racun-stavke">
            <div class="redak" v-if="this.$store.state.documentSide === 1 && !doRetail">
              <span>{{ lang.ItemVAT1Percentage }}</span><b>{{ localMoney(iVAT1Percentage) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1 && !doRetail">
              <span>{{ lang.ItemPriceWithVAT }}</span><b>{{ localMoney(iPriceWithVAT) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1 && !doRetail">
              <span>{{ langItemAmountWithVAT }}</span><b>{{ localMoney(iAmountWithVAT) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1 && exportDoc">
              <span>{{ lang.ItemExRate }}</span><b>{{ localMoney(ExRate) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1 && exportDoc">
              <span>{{ lang.itemSuppBasePercentageExp }}</span><b>{{ localMoney(iSuppBasePercentageExp) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1 && exportDoc">
              <span>{{ lang.itemDependablesAmount }}</span><b>{{ localMoney(iDependablesAmount) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1">
              <span>{{ lang.ItemSuppPriceAmount }}</span><b>{{ localMoney(iSuppPriceAmount) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1">
              <span>{{ lang.ItemSuppPrice }}</span><b>{{ localMoney(iSuppPrice) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1">
              <span>{{ lang.FreeF2 }}</span><b>{{ localMoney(iFreeF2) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 1">
              <span>{{ lang.ItemMarginAmount }}</span><b>{{ localMoney(iMarginAmount) }}</b>
            </div>
            <div class="redak" v-if="!hidePurchase && (this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3)">
              <span>{{ langItemMargin }}</span><b>{{ localMoney(iMargin) }}</b>
            </div>
            <div class="redak" v-if="!hidePurchase && (this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3)">
              <span>{{ langItemMarginAmount }}</span><b>{{ localMoney(iMarginAmount) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3">
              <span>{{ lang.ItemMaxDiscount }}</span><b>{{ localMoney(iMaxDiscount) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3">
              <span>{{ langItemBaseAmount }}</span><b>{{ localMoney(showExport ? iBaseForeAmount : iBaseAmount) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3">
              <span>{{ lang.ItemDiscountPrice }}</span><b>{{ localMoney(showExport ? iDiscountForePrice : iDiscountPrice) }}</b>
            </div>
            <div class="redak" v-if="this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3">
              <span>{{ langItemBaseAmountNoVAT }}</span><b>{{ localMoney(showExport ? iBaseForeAmountNoVAT : iBaseAmountNoVAT) }}</b>
            </div>
            <div class="redak" v-if="(this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3)">
              <span>{{ lang.ItemVAT1Percentage }}</span><b>{{ localMoney(showExport ? iForeVAT1Percentage : iVAT1Percentage) }}</b>
            </div>
            <div class="redak" v-if="(this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3)">
              <span>{{ lang.ItemVAT1Amount }}</span><b>{{ localMoney(showExport ? iForeVAT1Amount : iVAT1Amount) }}</b>
            </div>
            <!-- Cijena s PDV-om po komadu: na ulaznom dokumentu je u izracunu
                 stajala odavno, na izlaznom je nedostajala iako se racuna isto. -->
            <div class="redak" v-if="(this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3)">
              <span>{{ lang.ItemPriceWithVAT }}</span><b>{{ localMoney(showExport ? iForePriceWithVAT : iPriceWithVAT) }}</b>
            </div>
            <div class="redak" v-if="(this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3)">
              <span>{{ langItemAmountWithVAT }}</span><b>{{ localMoney(showExport ? iForeAmountWithVAT : iAmountWithVAT) }}</b>
            </div>
            <div class="redak">
              <span>{{ lang.ItemDirectDuty1Amount }}</span><b>{{ localMoney(showExport ? iDirectDuty1AmountFore : iDirectDuty1Amount) }}</b>
            </div>
            <div class="redak">
              <span>{{ langItemFullTotal }}</span><b>{{ localMoney(showExport ? iFullTotalFore : iFullTotal) }}</b>
            </div>
            <div class="redak zbroj">
              <span>{{ lang.LineTotal }}</span><b>{{ localMoney(showExport ? iFullTotalFore : iFullTotal) }}</b>
            </div>
              </v-card-text>
          </v-card>

          <div v-if="$store.state.documentActiv === 'InvoiceSales' || $store.state.documentActiv === 'ContractSales'">
            <v-card  class="pa-2 ma-1"  outlined>

              <v-card-title class="naslov-kartice">
                {{ lang.eRacun }}
                <v-spacer></v-spacer>
                <!-- Sklopljeno, ali sa sazetkom: bez otvaranja se vidi je li
                     kategorija PDV-a i KPD sifra uopce postavljena. -->
                <v-btn text small color="primary" class="pa-0 sazetak-gumb" @click="showERacun = !showERacun" :title="sazetakERacun">
                  <v-icon small>{{ showERacun ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  <span class="sazetak">{{ sazetakERacun }}</span>
                </v-btn>
              </v-card-title>
              <div v-if="showERacun">
              <div class="pt-3"></div>
              <v-row no-gutters>
                  <v-col cols="12" sm="10" md="10" lg="10" xl="10" >
                      <v-select
                      outlined dense hide-details="auto"
                        label="Oznaka kategorije PDVa"
                        :items="$store.state.OznakaKategorijePDV"
                        v-model="selectKategorije"
                        item-text="text"
                        item-value="id"
                        return-object
                        @change="choosedKategorije(selectKategorije)"
                        clearable
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="selectKategorije.id === 4 || selectKategorije.id === 8 || selectKategorije.id === 14">
                  <v-col cols="12" sm="10" md="10" lg="10" xl="10" >
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      label="Obavezan opis!"
                      v-model="iTaxExemptionReason"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" sm="10" md="10" lg="10" xl="10" >
                      <v-autocomplete
                      outlined dense hide-details="auto"
                        label="KPD (Klasus) šifra"
                        :items="$store.state.klasus"
                        v-model="selectKlasus"
                        item-text="klasusFind"
                        item-value="id"
                        return-object
                        @change="choosedKlasus(selectKlasus)"
                        clearable
                        ></v-autocomplete>
                    </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

            </v-col>
          </v-row>

          <!-- Zbroj stavke i radnje, uvijek na dnu ekrana - isto kao na
               dokumentu i u knjizi. Iznos se vidi bez skrolanja do dna. -->
          <div class="podnozje-dok">
            <div class="stavka">
              <span>{{ lang.LineTotal }}</span>
              <b>{{ localMoney(showExport ? iFullTotalFore : iFullTotal) }}</b>
            </div>
            <v-spacer></v-spacer>
            <v-btn small color="green" class="mr-2" :disabled="!formIsValid" @click="register">
              {{langC.Save}}
            </v-btn>
            <v-btn small outlined color="primary" @click="documentdetaillist">
              {{langC.Back}}
            </v-btn>
          </div>

      </v-col>
    </v-row>

    <!-- <div v-if="this.showItemCard"> -->
      <v-dialog
        v-model="showItemCard"
        activator="parent"
        width="600"
      >
        <v-row class="pt-2">
            <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
              <ItemViewCard2 />
          </v-col>
        </v-row>
     </v-dialog>
    <!-- </div> -->

    <!-- <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="12" lg="12" xs="12" sm="12" md="12" class="pa-0">
        <div v-if="this.statewhs">
            <v-row class="pt-2">
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <appDocumentWarehouseState></appDocumentWarehouseState>
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row> -->

    <v-dialog
        v-model="statewhs"
        activator="parent"
        width="auto"
      >
        <appDocumentWarehouseState/>
      </v-dialog>

      <v-dialog
        v-model="suppcard"
        activator="parent"
        width="auto"
      >
        <appDocumentItemCard />
       </v-dialog>

    <!-- <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="12" lg="12" xs="12" sm="12" md="12" class="pa-0">
        <div v-if="this.suppcard">
            <v-row class="pt-2">
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <appDocumentItemCard />
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row> -->

    <v-dialog
        v-model="sellcard"
        activator="parent"
        width="auto"
      >
        <appDocumentItemCardSales></appDocumentItemCardSales>
    </v-dialog>

    <!-- <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="12" lg="12" xs="12" sm="12" md="12" class="pa-0">
        <div v-if="this.sellcard">
            <v-row class="pt-2">
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <appDocumentItemCardSales></appDocumentItemCardSales>
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row> -->
    <v-dialog
        v-model="newItemCreate"
        activator="parent"
        width="auto"
      >
        <ItemCreate />
    </v-dialog>

     <!-- <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="10" lg="10" xs="12" sm="12" md="10" class="pa-0">
        <div v-if="this.newItemCreate">
            <v-row>
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <ItemCreate />
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row> -->

    <v-dialog
        v-model="showConditionGroup"
        activator="parent"
        width="auto"
      >
        <ItemListFast :conditionGroup="conditionGroup" />
    </v-dialog>

    <!-- <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="12" lg="12" xs="12" sm="12" md="12" class="pa-0">
        <div v-if="this.showConditionGroup">
            <v-row>
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <ItemListFast :conditionGroup="conditionGroup" />
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row> -->

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      bottom
      :color="color"
      >
      {{ text }}
    </v-snackbar>

  </v-container>
  </v-form>
</template>

<script>
// import _ from 'lodash'
import langEn from './documentDescEn'
import maxPopust from '@/snippets/maxPopust'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import ItemService from '@/services/ItemService'
import DocumentWarehouseState from './DocumentWarehouseState'
import DocumentItemCard from './DocumentItemCard'
import DocumentItemCardSales from './DocumentItemCardSales'
import ItemCreate from '../Item/ItemCreate'
import ItemViewCard2 from '../Item/ItemViewCard2'
import ItemListFast from '../Item/ItemListFast'
import {defDocumentDetail, defNewDocumentDetail} from './documentHelper'
import { mapGetters } from 'vuex'
import {parseNum} from '@/snippets/allSnippets'
import moneyFormat from '@/snippets/moneyFormat'
import { newUpdates, testLastUpdate } from '../../services/TestLastUpdate'
// Trazenje artikla bez obzira na kvacice i redoslijed rijeci.
import { sveRijeci } from '@/snippets/tekst'
import dayjs from 'dayjs'

export default {
  name: 'documentdetailcreate2',
  $validates: true,
  data () {
    return {
      snackbar: false,
      alert: true,
      text: '',
      timeout: 2000,
      color: 'green',
      numberValue: 0,
      lang: {},
      langC: {},
      docdetailitems: [],
      menu: false,
      menu2: false,
      menu3: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      date1: null,
      date2: null,
      msg: '',
      valid: true,
      documentName: '',
      documentNameLoc: '',
      documentDet: {
      },
      itemTotalPrice: 0,
      error: null,
      typeError: null,
      localError: false,
      newDocument: {},
      size: 'sm',
      required: (value) => !!value || 'Required.',
      itemsLoc: [],
      itemLoc: {},
      CompanyId: 0,
      selectIL: {},
      sumDoc: {
        documentTotalVAT1Per: 0,
        documentTotalVAT1Base: 0,
        documentTotalVAT1Amount: 0,
        documentTotalVAT2Per: 0,
        documentTotalVAT2Base: 0,
        documentTotalVAT2Amount: 0,
        documentTotalVAT3Per: 0,
        documentTotalVAT3Base: 0,
        documentTotalVAT3Amount: 0,
        documentTotalVAT4Per: 0,
        documentTotalVAT4Base: 0,
        documentTotalVAT4Amount: 0,
        documentTotalVAT5Per: 0,
        documentTotalVAT5Base: 0,
        documentTotalVAT5Amount: 0,
        documentTotalAmountNetto: 0,
        documentTotalAmountVAT: 0,
        documentTotalAmountBrutto: 0,
        documentTotalAmountPayInAdvance: 0,
        documentTotalAmountToPay: 0,
        documentTotalAmountNettoForeign: 0,
        documentTotalAmountVATForeign: 0,
        documentTotalAmountBruttoForeign: 0,
        documentTotalAmountPayInAdvanceForeign: 0,
        documentTotalAmountToPayForeign: 0,
        documentTotalAmountDirectD1: 0,
        documentTotalAmountDirectD2: 0,
        documentTotalAmountDirectD1Fore: 0,
        documentTotalAmountDirectD2Fore: 0
      },
      mainQuery: {
        CompanyId: 1,
        BusinessYear: 0,
        documentName: '',
        databaseDocID: 0
      },
      mainQuery2: {
        CompanyId: 1,
        itemID: ''
      },
      currnecyType: [
        { text: 'Kn', value: 'Kn' },
        { text: 'EUR', value: 'EUR' },
        { text: 'USD', value: 'USD' },
        { text: 'GBP', value: 'GBP' },
        { text: 'CHF', value: 'CHF' }
      ],
      money: {
        prefix: '= ',
        suffix: ' ',
        precision: 3
      },
      documentUpdated: {},
      price: 1,
      pcsLoc: 0,
      suppAmount: 0,
      suppNetoAmount: 0,
      maxDisc: 0,
      maxDiscPer: 0,
      haveEdit: false,
      noCalculate: false,
      haveNotice: '',
      firstUpdate: 0,
      workOn: false,
      fullpriceChange: true,
      // Smjer racuna na primci kad je olovka zakljucana:
      //   false -> slijeva nadesno: dobavna + marza daju cijenu
      //   true  -> upisana je CIJENA bez PDV-a, pa se marza racuna unatrag,
      //            a PDV i cijena s PDV-om unaprijed
      // Bez ovoga je "marginFromLeft" odmah pregazio upisanu cijenu
      // vrijednoscu izracunatom iz marze, pa se cinilo da polje ne radi.
      cijenaRucno: false,
      fullpriceBtn: 'Change',
      itemIndex: 0,
      activItems: [],
      calcVersion: 1,
      statewhs: false, 
      suppcard: false,
      outcard: false,
      sellcard: false,
      groupcard: false,
      newItemCreate: false,
      privGroups: [],
      selectGroup: {},
      documentAna: {
        CompanyId: 0,
        BusinessYear: 0,
        UserId: 0,
        partnerId: 0,
        documentName: '',
        docFromDate: null,
        docToDate: null,
        itemID: null,
        WareHouseId: null
      },
      payInAdvance: 0,
      exportDoc: false,
      ppo:false,
      langItemPrice: '',
      langItemBaseAmount: '',
      langItemBaseAmountNoVAT: '',
      langItemAmountWithVAT: '',
      langItemFullTotal: '',
      langItemSuppPrice: '',
      langItemMargin: '',
      langItemMarginAmount: '',
      ExRate: this.$store.getters.NeedDefExRate,
      homeDiscount : 0,
      exportDiscount: 0,
      homePriceWithVAT : 0,
      itemPrice: 0,
      peaces: 1,
      margin: 0,
      suppPrice: 0,
      suppDiscount: 0,
      emptyObj: {},
      ePrice: 0,
      ePcs: 0,
      showConditionGroup: false,
      conditionGroup: null,
      projectTypes: [],
      selectPT: {},
      showPT: false,
      haveItemSelected: false,
      iID: '',
      iName: '',
      iNameShort: '',
      iCode: '',
      iEANCode: '',
      iGroup: '',
      iGroupName: '',
      iForceNewPrintPage: false,
      iDescription: '',
      iUnit: '',
      iSize: '',
      iWeight: 0,
      iWeightMeasure: '',
      iDimMeasure: '',
      iDimLenght: 0,
      iDimHeight: 0,
      iDimDepth: 0,
      iWarehouse: '',
      iWarehouseRow: '',
      iWarehouseShelf: '',
      iWahrehouseFloor: '',
      iPicture1: '',
      iPicture2: '',
      iPicture3: '',
      iPicture4: '',
      iPicture5: '',
      iPicture6: '',
      iPicture7: '',
      // Koja je od sedam slika zadana (1..7); null = artikl nema zadanu sliku.
      iDefaultPicture: null,
      iBelongsToId: 0,
      iService: false,
      iWeb: false,
      iNotActiv: false,
      iHideForever: false,
      iHomeCurrency: '',
      iForeignCurrency: '',
      iExRate: 0,
      iTransport: 0,
      iTransportAmount: 0,
      iCustom: 0,
      iCustomAmount: 0,
      iDependables: 0,
      iDependablesAmount: 0,
      iSuppBaseForePrice: 0,
      iSuppBasePercentageExp: 0,
      iSuppBaseForePrice2: 0,
      iSuppBaseForeAmount: 0,
      iSuppBasePrice: 0,
      iSuppBasePriceAmount: 0,
      iSuppDiscount: 0,
      iSuppDiscountAmount: 0,
      iSuppPrice: 0,
      iSuppPriceAmount: 0,
      iSuppCode: '',
      iMargin: 0,
      iMarginAmount: 0,
      iMaxDiscount: 0,
      iPrice: 0,
      iVAT1Percentage: 0,
      iVAT1Amount: 0,
      iVAT2Percentge: 0,
      iVAT2Amount: 0,
      iDirectDuty1: 0,
      iDirectDuty2: 0,
      iPriceWithVAT: 0,
      iForePrice: 0,
      iForeVAT1Percentage: 0,
      iForeVAT1Amount: 0,
      iForeVAT2Percentage: 0,
      iForeVAT2Amount: 0,
      iForeDirectDuty1: 0,
      iForeDirectDuty2: 0,
      iForePriceWithVAT: 0,
      iBaseAmount: 0,
      iBaseForeAmount: 0,
      iDiscountAmount1: 0,
      iDiscountForeAmount1: 0,
      iDiscountPercentage1: 0,
      iDiscountAmount2: 0,
      iDiscountPercentage2: 0,
      iDiscountAmount3: 0,
      iDiscountPercentage4: 0,
      iDiscountPrice: 0,
      iDiscountForePrice: 0,
      iSerialNr: '',
      iPcsPlus: 0,
      iPcsMinus: 0,
      iPcsNeutral: 0,
      iBaseAmountNoVAT: 0,
      iBaseForeAmountNoVAT: 0,
      iBaseAmountWithVAT: 0,
      iBaseForeAmountWithVAT: 0,
      iAmountWithVAT: 0,
      iFullTotal: 0,
      iFullTotalFore: 0,
      iForeAmountWithVAT: 0,
      iDirectDuty1Amount: 0,
      iDirectDuty2Amount: 0,
      iDirectDuty1AmountFore: 0,
      iDirectDuty2AmountFore: 0,
      niPrice: 0,
      niBaseAmount: 0,
      niVAT1Percentage: 0,
      niVAT1Amount: 0,
      niAmountWithVAT: 0,
      niDirectDuty1: 0,
      niFullTotal: 0,
      iexportDoc: false,
      iitemPriceOriginal: 0,
      iitemFullPriceOriginal: 0,
      iFreeF1: 0,
      iFreeF2: 0,
      iFreeF3: 0,
      iFreeF4: 0,
      iFreeF5: 0,
      iFreeF6: 0,
      iTypeID: 0,
      iTypeName: '',
      showExport: false,
      showDesc: false,
      doRetail: false,
      marginIsZero: false,
      showItemCard: false,
      hidePurchase: false,
      showOptions: false,
      showERacun: false,
      showItemDetails: false,
      iTaxExemptionReason: 'Na temelju članka 90. stavak 1. Zakona o PDV-u, PDV nije uračunat u cijenu.',
      // infoSuppBaseForePrice: 0,
      // infoSuppBasePrice: 0,
      // infoSuppDiscount: 0,
      // infoSuppPrice: 0,
      // infoMargin: 0,
      kategorije:[],
      selectKategorije: {},
      klasus: [],
      selectKlasus: {},
      searcFor: false,
      radimEdit: false,
      radimNovi: false,
      componentKey: 0
    }
  },
  components: {
    appDocumentWarehouseState: DocumentWarehouseState,
    appDocumentItemCard: DocumentItemCard,
    appDocumentItemCardSales: DocumentItemCardSales,
    ItemCreate,
    ItemListFast,
    ItemViewCard2
  },
  async created () {
 
  },
  async mounted () {
    this.$store.dispatch('setItemFromXML', null)
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.exportDoc = this.$store.state.documentActivHead.exportDoc
    this.ppo = this.$store.state.documentActivHead.ppo
    if (this.exportDoc && this.$store.state.documentActiv === 'ReceiptPurchase') {
      this.showExport = false
    }
    if (this.exportDoc && this.$store.state.documentActiv !== 'ReceiptPurchase') {
      this.showExport = true
    }
    this.doRetail = this.$store.state.companyActiv.CompanyUseRetailPrice

    this.hidePurchase = this.$store.state.user && this.$store.state.user.sales2 ? this.$store.state.user.sales2  : false

    this.iTaxExemptionReason = this.$store.state.companyActiv.notinVAT === true ? 'Nije u sustavu PDVa' : 'Na temelju članka 90. stavak 1. Zakona o PDV-u, PDV nije uračunat u cijenu.'

    let haveCurrency = ''
    if (this.exportDoc === false) {
      haveCurrency = this.$store.state.documentActivHead.documentHomeCurrency ? (' ' + this.$store.state.documentActivHead.documentHomeCurrency) : ''
    } else {
      if (this.showExport) {haveCurrency = this.$store.state.documentActivHead.documentForeignCurrency ? (' ' + this.$store.state.documentActivHead.documentForeignCurrency) : ''}
      if (!this.showExport) {haveCurrency = this.$store.state.documentActivHead.documentHomeCurrency ? (' ' + this.$store.state.documentActivHead.documentHomeCurrency) : ''}
    }
    this.langItemPrice = this.lang.ItemPrice + haveCurrency
    this.langItemBaseAmount = this.lang.ItemBaseAmount + haveCurrency
    this.langItemBaseAmountNoVAT = this.lang.ItemBaseAmountNoVAT + haveCurrency
    this.langItemAmountWithVAT = this.lang.ItemAmountWithVAT + haveCurrency
    this.langItemFullTotal = this.lang.ItemFullTotal + haveCurrency
    this.langItemSuppPrice = this.lang.ItemSuppPrice + (this.$store.state.businessYear <= 2022 ? 'Kn' : 'EUR')
    this.langItemMargin = this.lang.ItemMargin
    this.langItemMarginAmount = this.lang.ItemMarginAmount + (this.$store.state.businessYear <= 2022 ? 'Kn' : 'EUR')
    
    this.ExRate = this.$store.state.documentActivHead.documentExRate && parseFloat(this.$store.state.documentActivHead.documentExRate) > 1 ? parseFloat(this.$store.state.documentActivHead.documentExRate) : 1
    this.iExRate = this.ExRate
    this.iSuppBasePercentageExp = this.$store.state.documentActivHead.expenesPercent && parseFloat(this.$store.state.documentActivHead.expenesPercent) > 0 ? parseFloat(this.$store.state.documentActivHead.expenesPercent) : 0

    this.projectTypes = this.$store.state.projectTypes ? this.$store.state.projectTypes : []
    const docName = this.$store.state.documentActiv
    if (docName === 'InvoiceSales' || docName === 'DeliveryNoteSales' || docName === 'InternalDeliveryNotes') {
      this.showPT = true
    }
    console.log('LOAD this.$store.state.editItem: ', this.$store.state.editItem);
    // if add new item in items
    this.$store.dispatch('setnewItemAround', false)
    // if NEW item
    if (this.$store.state.editItem === 0 ) {
      
      this.newItem = true
      this.firstUpdate = 3
      await this.makeItNew()
    }


    // if edit item
    if (this.$store.state.editItem === 1 && this.$store.state.documentdetailid) {
      this.radimEdit = true
      const itemOnly = this.$store.state.documentActivItems.find(item => {
        return item.id === this.$store.state.documentdetailid
      })
      this.$store.dispatch('setItemActiv', itemOnly)
      await Object.assign(this.documentDet, itemOnly)
      await this.assignIt(itemOnly, 0)
      this.itemIndex = this.$store.state.documentActivItems.indexOf(itemOnly)
      
      if (this.documentDet.itemID) {
        this.componentKey += 1
        this.selectIL =
        {
          itemByID: (this.documentDet.itemID + ' ' + this.documentDet.itemName),
          itemID: this.documentDet.itemID,
          key: this.componentKey
        }
        this.haveItemSelected = true
      }
      this.showDesc = this.iDescription && this.iDescription.trim().length > 0 ? true : false

      await this.initPcs()
      this.suppDiscount = this.iSuppDiscount
      this.selectPT = this.defaultItem && this.defaultItem.TypeID ? this.projectTypes.find(element => element.id === this.defaultItem.TypeID) : null

      const result = this.$store.state.OznakaKategorijePDV.filter(element => element.value === this.documentDet.kod)
      if (result[0]) {
        this.selectKategorije = result[0]
      }
      if (this.$store.state.companyActiv.notinVAT === true) {
        const result = this.$store.state.OznakaKategorijePDV.filter(element => element.id === 13)
        if (result[0]) {
          this.selectKategorije = result[0]
        }
      }
      const result2 = this.$store.state.klasus.filter(element => element.PotpunaSifra === this.documentDet.PotpunaSifra)
        if (result2[0]) {
          this.selectKlasus = result2[0]
        }
      this.radimEdit = false
    }

    this.documentName = this.$store.state.documentActiv
    this.documentNameLoc = this.$store.state.documentActivLoc
    this.itemsLoc = this.$store.state.itemStore ? this.$store.state.itemStore : []
    this.privGroups = this.$store.state.groupStore ? this.$store.state.groupStore : []
    this.workOn = true
  },
  computed: {
    // PDV po JEDNOM komadu, za prikaz na primci. "iVAT1Amount" je iznos za
    // cijelu kolicinu, a red polja na primci je racun po komadu:
    //   dobavna umanjena + marza iznos = cijena bez PDV-a
    //   cijena bez PDV-a + PDV po komadu = cijena s PDV-om
    // Racuna se kao razlika te dvije cijene, da se zbroj na ekranu uvijek
    // poklapa s onim sto korisnik vidi, bez centa razlike od zaokruzivanja.
    iPdvPoKomadu () {
      const bez = parseFloat(this.iPrice) || 0
      const sPdv = parseFloat(this.iPriceWithVAT) || 0
      return this.round(sPdv - bez, 2)
    },
    // Sazetak za sklopljenu skupinu eRacuna - da se bez otvaranja vidi je li
    // postavljeno ono sto Fiskalizacija 2.0 trazi.
    sazetakERacun () {
      const kategorija = this.selectKategorije && this.selectKategorije.text ? this.selectKategorije.text : ''
      const kpd = this.selectKlasus && this.selectKlasus.klasusFind ? this.selectKlasus.klasusFind : ''
      if (!kategorija && !kpd) { return this.lang.eRacunNotSet }
      // Bez rezanja na 60 znakova: visak sada skracuje CSS trotockom, a
      // cijeli tekst ostaje u "title" pa se procita na prelazak misem.
      return [kategorija, kpd].filter(x => x).join(' · ')
    },
    // Cijena s PDV-om + direktna naknada, po komadu - ono sto kupac plati za
    // jedan komad. Naknada se vodi po komadu (iDirectDuty1Amount je naknada
    // pomnozena s kolicinom), pa se smije zbrojiti s cijenom po komadu.
    ukupnoSNaknadom () {
      const cijena = this.showExport ? this.iForePriceWithVAT : this.iPriceWithVAT
      const naknada = this.showExport ? this.iForeDirectDuty1 : this.iDirectDuty1
      return this.round((Number(cijena) || 0) + (Number(naknada) || 0), 2)
    },
    formIsValid () {
      return this.iID !== ''
    },
    ...mapGetters({
      mySelectedItemId: 'NeedSelectedItemId'
    }),
  },
  methods: {
    // Predlozak ga koristi kao ":filter" na odabiru artikla; uvezena funkcija
    // nije vidljiva u predlosku dok se ovako ne izlozi.
    sveRijeci,
    localMoney (iznos) {
      return moneyFormat(iznos)
    },
    optionsOn () {
      this.showOptions = !this.showOptions
    },
    itemDetailsOn () {
      this.showItemDetails = !this.showItemDetails
    },
    addDesc () {
      this.showDesc = !this.showDesc
    },
    showItemCardd () {
      this.showItemCard = !this.showItemCard
    },
    async checkSupplierPrice() {
      if (this.iID) {
        if (!this.iService) {
          this.mainQuery2 = {...this.emptyObj}
          this.mainQuery2.CompanyId = this.$store.state.companyid
          this.mainQuery2.itemID = this.iID ? this.iID : null
          await ItemService.choose(this.mainQuery2)
          .then((res) => {
            if (res.data && res.data.item !== undefined) {
              this.initPcs()
              this.iSuppBasePrice = parseNum(res.data.item.itemSuppPrice, 2)
              this.iSuppPrice = parseNum(res.data.item.itemSuppPrice, 2)
              this.iSuppDiscount = 0
              this.iSuppDiscountAmount = 0
              this.iSuppBasePriceAmount  = (this.iSuppBasePrice * this.pcsLoc) ? this.round((this.iSuppBasePrice * this.pcsLoc),2) : 0
              this.iSuppPriceAmount = this.iSuppBasePriceAmount
              this.calculateMarginSale()
            }
            this.text = 'OK.'
            this.color = 'green'
            this.snackbar = true
          })
          .catch(err => {
            console.log(' Error items ', err)
            this.text = this.lang.UpdateItemNameUpdatedError
            this.color = 'red'
            this.snackbar = true
          })
        }
        if (this.iService){
          this.calculateMarginSale()
        }
      }
    },
    warehouseState() {
      this.statewhs = !this.statewhs
      this.$store.dispatch('setdontGo', false)
      this.$store.dispatch("setGroupid", null)
      if (this.selectGroup && this.selectGroup.id) {
        this.$store.dispatch("setGroupid", this.selectGroup.id)
      }
    },
    showGroup() {
      this.conditionGroup = null
      this.$store.dispatch('setSelectedItemId', null)
      if (this.selectGroup && this.selectGroup.id) {
        this.conditionGroup = this.selectGroup.id
      }
      this.showConditionGroup = !this.showConditionGroup
    },
    choosedProjectType (choosedPT) {
      if (choosedPT) {
        const result = this.projectTypes.filter(element => element.id === choosedPT.id)
        if (result[0]) {
          const res = result[0]
          this.documentDet.TypeID = res.id
          this.documentDet.TypeName = res.TypeName
          this.selectPT = res
        } else {
          this.text = this.lang.MainLedgerProjectTypeEmpty
          this.color = 'red'
          this.snackbar = true
        }
      } else {
        this.documentDet.TypeID = null
        this.documentDet.TypeName = null
      }     
    },
    choosedKategorije (choosedK) {
      if (choosedK) {
        const result = this.$store.state.OznakaKategorijePDV.filter(element => element.id === choosedK.id)
        if (result[0]) {
          const res = result[0]
          this.documentDet.kod = res.value
          this.documentDet.kodKategorije = res.kodKategorije
          this.documentDet.kodSheme = res.kodSheme
          this.selectKategorije = res
        } else {
          this.text = 'Nije odabran ispravn kod!'
          this.color = 'red'
          this.snackbar = true
        }
      } else {
        this.documentDet.kod = null
        this.documentDet.kodKategorije = null
        this.documentDet.kodSheme = null
      }     
    },
    choosedKlasus (choosedK) {
      if (choosedK) {
        const result = this.$store.state.klasus.filter(element => element.id === choosedK.id)
        if (result[0]) {
          const res = result[0]
          this.documentDet.PotpunaSifra = res.PotpunaSifra
          this.selectKlasus = res
        } else {
          this.text = 'Nije odabran ispravn kod!'
          this.color = 'red'
          this.snackbar = true
        }
      } else {
        this.documentDet.PotpunaSifra = null
      }     
    },
    createNewItem() {
      // Ovdje je stajalo "documentActiv = 'ReceiptPurchase'" - jedan znak
      // jednakosti umjesto usporedbe. Uvjet je zato uvijek prolazio, a usput
      // je vrsta dokumenta u storeu prepisivana u primku, pa je aplikacija
      // nakon klika na "Novi artikal" mislila da je na primci.
      //
      // Provjera vrste je maknuta, a ne ispravljena u "===", da se zadrzi
      // ponasanje na koje su korisnici navikli: podaci se prepisuju u novi
      // artikl na svakoj vrsti dokumenta, ne samo na primci.
      if (this.iName.length > 0) {
        console.log('1 radim PREdata')
        const preData = {}
        preData.itemName = this.iName
        preData.ItemNameShort = this.iNameShort
        preData.ItemCode = this.iCode
        preData.ItemEANCode = this.iEANCode
        preData.itemGroup = this.iGroup
        preData.itemGroupName = this.iGroupName
        preData.forceNewPrintPage = this.iForceNewPrintPage
        preData.itemDescription = this.iDescription
        preData.itemUnit = this.iUnit
        preData.ItemSize = this.iSize
        preData.ItemWeight = this.iWeight
        preData.ItemWeightMeasure = this.iWeightMeasure
        preData.ItemDimMeasure = this.iDimMeasure
        preData.ItemDimLenght = this.iDimLenght
        preData.ItemDimHeight = this.iDimHeight
        preData.ItemDimDepth = this.iDimDepth
        preData.ItemWarehouse = this.iWarehouse
        preData.ItemWarehouseRow = this.iWarehouseRow
        preData.ItemWarehouseShelf = this.iWarehouseShelf
        preData.ItemWahrehouseFloor = this.iWahrehouseFloor
        preData.ItemPicture1 = this.iPicture1
        preData.ItemPicture2 = this.iPicture2
        preData.ItemPicture3 = this.iPicture3
        preData.ItemPicture4 = this.iPicture4
        preData.ItemPicture5 = this.iPicture5
        preData.ItemPicture6 = this.iPicture6
        preData.ItemPicture7 = this.iPicture7
        preData.ItemDefaultPicture = this.iDefaultPicture
        preData.ItemBelongsToId = this.iBelongsToId
        preData.itemService = this.iService
        preData.itemWeb = this.iWeb
        preData.itemNotActiv = this.iNotActiv
        preData.itemHideForever = this.iHideForever
        preData.ItemHomeCurrency = 'EUR'
        preData.ItemForeignCurrency = 'EUR'
        preData.ItemExRate = 1
        preData.itemSuppBasePrice = this.iSuppBasePrice
        preData.itemSuppBasePriceAmount = this.iSuppBasePriceAmount
        preData.itemSuppDiscount = this.iSuppDiscount
        preData.itemSuppDiscountAmount = this.iSuppDiscountAmount
        preData.itemSuppPrice = this.iSuppPrice
        preData.itemSuppPriceAmount = this.iSuppPriceAmount
        preData.ItemSuppCode = this.iSuppCode
        preData.itemMargin = this.iMargin
        preData.itemMarginAmount = this.iMarginAmount
        preData.itemMaxDiscount = this.iMaxDiscount
        preData.itemPrice = this.iPrice
        preData.itemVAT1Percentage = this.iVAT1Percentage
        preData.itemVAT1Amount = this.iVAT1Amount
        preData.itemVAT2Percentge = this.iVAT2Percentge
        preData.itemVAT2Amount = this.iVAT2Amount
        preData.itemDirectDuty1 = this.iDirectDuty1
        preData.itemDirectDuty2 = this.iDirectDuty2
        preData.itemPriceWithVAT = this.iPriceWithVAT
        preData.itemForePrice = this.iForePrice
        preData.itemForeVAT1Percentage = this.iForeVAT1Percentage
        preData.itemForeVAT1Amount = this.iForeVAT1Amount
        preData.itemForeVAT2Percentage = this.iForeVAT2Percentage
        preData.itemForeVAT2Amount = this.iForeVAT2Amount
        preData.itemForeDirectDuty1 = this.iForeDirectDuty1
        preData.itemForeDirectDuty2 = this.iForeDirectDuty2 
        preData.itemForePriceWithVAT = this.iForePriceWithVAT
        preData.itemBaseAmount = this.iBaseAmount 
        preData.itemBaseForeAmount = this.iBaseForeAmount
        preData.itemDiscountAmount1 = this.iDiscountAmount1
        preData.itemDiscountForeAmount1 = this.iDiscountForeAmount1
        preData.itemDiscountPercentage1 = this.iDiscountPercentage1
        preData.itemDiscountAmount2 = this.iDiscountAmount2
        preData.itemDiscountPercentage2 = this.iDiscountPercentage2
        preData.itemDiscountAmount3 = this.iDiscountAmount3
        preData.itemDiscountPercentage4 = this.iDiscountPercentage4
        preData.itemDiscountPrice = this.iDiscountPrice
        preData.itemDiscountForePrice = this.iDiscountForePrice
        preData.itemSerialNr = this.iSerialNr
        preData.itemPcsPlus = this.iPcsPlus
        preData.itemPcsMinus = this.iPcsMinus
        preData.itemPcsNeutral = this.iPcsNeutral
        preData.itemBaseAmountNoVAT = this.iBaseAmountNoVAT
        preData.itemBaseForeAmountNoVAT = this.iBaseForeAmountNoVAT
        preData.itemBaseAmountWithVAT = this.iBaseAmountWithVAT
        preData.itemBaseForeAmountWithVAT = this.iBaseForeAmountWithVAT
        preData.itemAmountWithVAT = this.iAmountWithVAT
        preData.itemFullTotal = this.iFullTotal
        preData.itemFullTotalFore = this.iFullTotalFore
        preData.itemForeAmountWithVAT = this.iForeAmountWithVAT
        preData.itemDirectDuty1Amount = this.iDirectDuty1Amount
        preData.itemDirectDuty2Amount = this.iDirectDuty2Amount
        preData.itemDirectDuty1AmountFore = this.iDirectDuty1AmountFore
        preData.itemDirectDuty2AmountFore = this.iDirectDuty2AmountFore
        preData.newitemPrice = 0
        preData.newitemBaseAmount = 0
        preData.newitemVAT1Percentage = 0
        preData.newitemVAT1Amount = 0
        preData.newitemAmountWithVAT = 0
        preData.newitemDirectDuty1 = 0
        preData.newitemFullTotal = 0
        preData.exportDoc = false
        preData.itemPriceOriginal = this.iPriceOriginal
        preData.itemFullPriceOriginal = this.iFullPriceOriginal
        this.$store.dispatch('setItemFromXML', preData)
      }

      this.$store.dispatch('setnewItemAround', true)
      this.newItemCreate = !this.newItemCreate
    },
    async initAna() {
      if (this.$store.state.companyid) {
        this.documentAna.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.documentAna.BusinessYear = this.$store.state.businessYear
      }
      if (this.selectIL.itemID) {
        this.documentAna.itemID = this.selectIL.itemID
      }
      this.documentAna.docFromDate = dayjs([this.documentAna.BusinessYear]).startOf('year').format('YYYY-MM-DD')
      this.documentAna.docToDate = dayjs([this.documentAna.BusinessYear]).endOf('year').format('YYYY-MM-DD')
      this.documentAna.WareHouseId = this.$store.state.documentAna.WareHouseId ? this.$store.state.documentAna.WareHouseId  : 1
      await this.$store.dispatch('setDocumentAna', this.documentAna)
    },
    itemCard() {
      if (this.selectIL.itemID) {
        this.initAna()  
        this.suppcard = !this.suppcard
      } else {
        this.text = this.lang.itemNotSelected
        this.color = 'red'
        this.snackbar = true
      }
    },
    itemCardMinus() {
      if (this.selectIL.itemID) {
        this.initAna()
        this.outcard = !this.outcard
      } else {
        this.text = this.lang.itemNotSelected
        this.color = 'red'
        this.snackbar = true
      }
    },
    itemCardSell() {
      if (this.selectIL.itemID) {
        this.initAna()
        this.sellcard = !this.sellcard
      } else {
        this.text = this.lang.itemNotSelected
        this.color = 'red'
        this.snackbar = true
      }
    },
    fullpriceSwitch() {
      this.fullpriceChange = !this.fullpriceChange
      // Olovka preuzima smjer racuna, pa rucno upisana cijena bez PDV-a
      // prestaje vrijediti.
      this.cijenaRucno = false
      this.initPcs()
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    doParse () {
      this.documentDet.ItemWeight = this.documentDet.ItemWeight ? parseFloat(this.documentDet.ItemWeight) : 0
      this.documentDet.ItemDimLenght = this.documentDet.ItemDimLenght ? parseFloat(this.documentDet.ItemDimLenght) : 0
      this.documentDet.ItemDimHeight = this.documentDet.ItemDimHeight ? parseFloat(this.documentDet.ItemDimHeight) : 0
      this.documentDet.ItemDimDepth = this.documentDet.ItemDimDepth ? parseFloat(this.documentDet.ItemDimDepth) : 0
      this.documentDet.ItemBelongsToId = this.documentDet.ItemBelongsToId ? parseFloat(this.documentDet.ItemBelongsToId) : 0
      this.documentDet.itemSuppBasePrice = this.documentDet.itemSuppBasePrice ? parseFloat(this.documentDet.itemSuppBasePrice) : 0
      this.documentDet.itemSuppBasePriceAmount = this.documentDet.itemSuppBasePriceAmount ? parseFloat(this.documentDet.itemSuppBasePriceAmount) : 0
      this.documentDet.itemSuppDiscunt = this.documentDet.itemSuppDiscunt ? parseFloat(this.documentDet.itemSuppDiscunt) : 0
      this.documentDet.itemSuppDiscuntAmount = this.documentDet.itemSuppDiscuntAmount ? parseFloat(this.documentDet.itemSuppDiscuntAmount) : 0
      this.documentDet.itemSuppPrice = this.documentDet.itemSuppPrice ? parseFloat(this.documentDet.itemSuppPrice) : 0
      this.documentDet.itemSuppPriceAmount = this.documentDet.itemSuppPriceAmount ? parseFloat(this.documentDet.itemSuppPriceAmount) : 0
      this.documentDet.ItemSuppCode = this.documentDet.ItemSuppCode ? parseFloat(this.documentDet.ItemSuppCode) : 0
      this.documentDet.itemMargin = this.documentDet.itemMargin ? parseFloat(this.documentDet.itemMargin) : 0
      this.documentDet.itemMarginAmount = this.documentDet.itemMarginAmount ? parseFloat(this.documentDet.itemMarginAmount) : 0
      this.documentDet.itemMaxDiscount = this.documentDet.itemMaxDiscount ? parseFloat(this.documentDet.itemMaxDiscount) : 0
      this.documentDet.itemPrice = this.documentDet.itemPrice ? parseFloat(this.documentDet.itemPrice) : 0
      this.documentDet.itemVAT1Percetage = this.documentDet.itemVAT1Percetage ? parseFloat(this.documentDet.itemVAT1Percetage) : 0
      this.documentDet.itemVAT1Amount = this.documentDet.itemVAT1Amount ? parseFloat(this.documentDet.itemVAT1Amount) : 0
      this.documentDet.itemVAT2Percentge =this.documentDet.itemVAT2Percentge ? parseFloat(this.documentDet.itemVAT2Percentge) : 0
      this.documentDet.itemVAT2Amount = this.documentDet.itemVAT2Amount ? parseFloat(this.documentDet.itemVAT2Amount) : 0
      this.documentDet.itemDirectDuty1 = this.documentDet.itemDirectDuty1 ? parseFloat(this.documentDet.itemDirectDuty1) : 0
      this.documentDet.itemDirectDuty2 = this.documentDet.itemDirectDuty2 ? parseFloat(this.documentDet.itemDirectDuty2) : 0
      this.documentDet.itemPriceWithVAT = this.documentDet.itemPriceWithVAT ? parseFloat(this.documentDet.itemPriceWithVAT) : 0
      this.documentDet.itemForePrice = this.documentDet.itemForePrice ? parseFloat(this.documentDet.itemForePrice) : 0
      this.documentDet.itemForeVAT1Percentage = this.documentDet.itemForeVAT1Percentage ? parseFloat(this.documentDet.itemForeVAT1Percentage) : 0
      this.documentDet.itemForeVAT1Amount = this.documentDet.itemForeVAT1Amount ? parseFloat(this.documentDet.itemForeVAT1Amount) : 0
      this.documentDet.itemForeVAT2Percentage = this.documentDet.itemForeVAT2Percentage ? parseFloat(this.documentDet.itemForeVAT2Percentage) : 0
      this.documentDet.itemForeVAT2Amount = this.documentDet.itemForeVAT2Amount ? parseFloat(this.documentDet.itemForeVAT2Amount) : 0
      this.documentDet.itemForeDirectDuty1 = this.documentDet.itemForeDirectDuty1 ? parseFloat(this.documentDet.itemForeDirectDuty1) : 0
      this.documentDet.itemForeDirectDuty2 = this.documentDet.itemForeDirectDuty2 ? parseFloat(this.documentDet.itemForeDirectDuty2) : 0
      this.documentDet.itemForePriceWithVAT = this.documentDet.itemForePriceWithVAT ? parseFloat(this.documentDet.itemForePriceWithVAT) : 0
      this.documentDet.itemPcsNeutral = this.documentDet.itemPcsNeutral ? parseFloat(this.documentDet.itemPcsNeutral) : 0
      this.documentDet.itemPcsMinus = this.documentDet.itemPcsMinus ? parseFloat(this.documentDet.itemPcsMinus) : 0
      this.documentDet.itemFullTotal = this.documentDet.itemFullTotal ? parseFloat(this.documentDet.itemFullTotal) : 0
      this.documentDet.itemFullTotalFore = this.documentDet.itemFullTotalFore ? parseFloat(this.documentDet.itemFullTotalFore) : 0
      this.documentDet.itemDirectDuty1Amount = this.documentDet.itemDirectDuty1Amount ? parseFloat(this.documentDet.itemDirectDuty1Amount) : 0
      this.documentDet.itemDirectDuty2Amount = this.documentDet.itemDirectDuty2Amount ? parseFloat(this.documentDet.itemDirectDuty2Amount) : 0
      this.documentDet.itemDirectDuty1AmountFore = this.documentDet.itemDirectDuty1AmountFore ? parseFloat(this.documentDet.itemDirectDuty1AmountFore) : 0
      this.documentDet.itemDirectDuty2AmountFore = this.documentDet.itemDirectDuty2AmountFore ? parseFloat(this.documentDet.itemDirectDuty2AmountFore) : 0
      this.documentDet.FreeF1 = this.documentDet.FreeF1 ? parseFloat(this.documentDet.FreeF1) : 0
      this.documentDet.FreeF2 = this.documentDet.FreeF2 ? parseFloat(this.documentDet.FreeF2) : 0
      this.documentDet.FreeF3 = this.documentDet.FreeF3 ? parseFloat(this.documentDet.FreeF3) : 0
      this.documentDet.FreeF4 = this.documentDet.FreeF4 ? parseFloat(this.documentDet.FreeF4) : 0
      this.documentDet.FreeF5 = this.documentDet.FreeF5 ? parseFloat(this.documentDet.FreeF5) : 0
      this.documentDet.itemPriceOriginal = this.documentDet.itemPriceOriginal ? parseFloat(this.documentDet.itemPriceOriginal) : 0
      this.documentDet.itemFullPriceOriginal = this.documentDet.itemFullPriceOriginal ? parseFloat(this.documentDet.itemFullPriceOriginal) : 0
    },
    async register () {
      try {
        this.localError = false
        console.log('Register this.$store.state.editItem: ', this.$store.state.editItem);
        await this.unassignIt()

        if (this.$store.state.editItem === 1) {
          const activItems = this.$store.state.documentActivItems ? this.$store.state.documentActivItems : []
          activItems.splice(this.itemIndex, 1, this.documentDet)
          if (activItems) {
            this.$store.dispatch('setDocumentActivItems', activItems)
          } else {
            this.$store.dispatch('setDocumentActivItems', [])
          }
          await this.$store.dispatch('seteditItem', 0)
          this.haveNotice = this.lang.itemUpdated
        } else {
          const newItem = this.documentDet
          this.activItems = this.$store.state.documentActivItems
          this.activItems.push(newItem)
          if (this.activItems) {
            this.$store.dispatch('setDocumentActivItems', this.activItems)
          } else {
            this.$store.dispatch('setDocumentActivItems', [])
          }
          this.haveNotice = this.lang.itemAdded
        }
        this.makeSum()
        this.$router.push({
          name: 'documentview'
        })
      } catch (error) {
        this.error = 'Greska u konekciji na bazu' + error
        this.typeError = 'error'
      }
    },
    close () {
      this.show = false
    },
    async updateItemName() {
      if (this.haveItemSelected) {
        const updateItem = {}
        updateItem.itemID = this.documentDet.itemID
        updateItem.itemName = this.documentDet.itemName
        updateItem.itemDescription = this.documentDet.itemDescription
        updateItem.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
        updateItem.PotpunaSifra = this.documentDet.PotpunaSifra ? this.documentDet.PotpunaSifra : ''
        updateItem.kod = this.documentDet.kod ? this.documentDet.kod : ''
        updateItem.kodKategorije = this.documentDet.kodKategorije ? this.documentDet.kodKategorije : ''
        updateItem.kodSheme = this.documentDet.kodSheme ? this.documentDet.kodSheme : ''

        const updateItems = []
        updateItems.push(updateItem)
        await ItemService.updateprices(updateItems)
        .then(async(res) => {
          console.log(res.data)
          this.text = this.lang.UpdateItemNameUpdated
          this.color = 'green'
          this.snackbar = true
          await newUpdates(1)
          await testLastUpdate()
          this.mainQuery.CompanyId = this.$store.state.companyid
          this.itemsLoc = (await ItemService.index(this.mainQuery)).data.items
          // if (this.itemsLoc) {
          //   this.$store.dispatch('setActivItems', this.itemsLoc)
          // }
        })
        .catch(err => {
          console.log(' Error items ', err)
          this.text = this.lang.UpdateItemNameUpdatedError
          this.color = 'red'
          this.snackbar = true
        })
      }
    },
    async deleteDD2 () {
      try {
        if (this.$store.state.documentdetailid) {
          const activItems = this.$store.state.documentActivItems.filter(item => {
            return item.id !== this.$store.state.documentdetailid
          })
          if (activItems) {
            this.$store.dispatch('setDocumentActivItems', activItems)
          } else {
            this.$store.dispatch('setDocumentActivItems', [])
          }
          // make sum local head
          this.makeSum()
          if (this.$store.state.language === 'EN') {
            this.error = 'Item is deleted.'
            this.typeError = 'success'
          }
          if (this.$store.state.language === 'HR') {
            this.error = 'Obrisana je stavka sa dokumenta'
            this.typeError = 'success'
          }
          
          await this.$router.push({
            name: 'documentview'
          })
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async documentdetaillist () {
      try {
        await this.$router.push({
          name: 'documentview'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    initPcs() {
      this.pcsLoc = 0

      if (this.$store.state.documentSide === 1) {
        this.pcsLoc = this.iPcsPlus ? this.iPcsPlus : 0
      }
      if (this.$store.state.documentSide === 2) {
        this.pcsLoc = this.iPcsMinus ? this.iPcsMinus : 0
      }
      if (this.$store.state.documentSide === 3) {
        this.pcsLoc = this.iPcsNeutral ? this.iPcsNeutral : 0
      }
      // Kolicina ide na 3 decimale, ne na 2. Tko prodaje u tonama upisuje npr.
      // 12,345 t, a zaokruzivanje na 12,35 t mijenja iznos racuna. Sve ostale
      // tocke u programu vec racunaju s 3 decimale; ovaj je ekran odstupao.
      // Sam izracun se NE zaokruzuje preko kolicine - mnozi se punom kolicinom,
      // a na 2 decimale se zaokruzuje tek iznos.
      this.pcsLoc = this.round(this.pcsLoc, 3)
      this.iFreeF4 = this.iSize && this.iSize !== 0 ? this.pcsLoc / this.iSize : 0
    },
    // initCalc() {
    //   if (this.fullpriceChange === true) {
    //     if (this.$store.state.documentSide === 1) {
    //       if (this.$store.state.documentActiv === 'ReceiptPurchase') {
    //         this.calculateSupp()
    //       }
    //     }
    //     if (this.exportDoc === false) {
    //       this.calculateDiscount()
    //     } else {
    //       this.calculateDiscountFore()
    //     } 
    //   }
    //   if (!this.fullpriceChange === true) {
    //     if (this.$store.state.documentSide === 1) {
    //       if (this.$store.state.documentActiv === 'ReceiptPurchase') {
    //         this.initSupp()
    //       }
    //     }
    //     if (this.exportDoc === false) {
    //       this.calculatePrice()
    //     } else {
    //       this.calculatePriceFore()
    //     } 
    //   }
    // },
    // ----------------------------------------------------------  >>>>>
    // ----------------------------------------------------------  >>>>>
    // --------------------------------------------------------------------------------  >>>>>
    inputDocCalc() {
      if (this.$store.state.documentSide === 1) {
        if (!this.doRetail) {
          this.initPcs()
          this.initSupp()
          if (this.fullpriceChange && this.cijenaRucno) {
            // Upisana je cijena bez PDV-a: iz nje ide PDV i cijena s PDV-om
            // unaprijed, a marza se racuna unatrag na dobavnu. Dobavna cijena
            // i rabat se NE diraju.
            this.finalFromLeft()
            this.marginFromRight()
          }
          if (this.fullpriceChange && !this.cijenaRucno) {
            this.marginFromLeft()
            this.finalFromLeft()
          }
          if (!this.fullpriceChange) {
            // Olovka je otkljucala "Cijena sa PDVom", pa se racuna UNATRAG:
            // iz upisane cijene s PDV-om prema osnovici i cijeni bez PDV-a.
            //
            // Ovdje je stajao finalFromLeft(), koji racuna u suprotnom smjeru
            // i na kraju sam prepise "iPriceWithVAT" iz cijene bez PDV-a - pa
            // je upisana cijena (npr. 12,99) nestajala cim bi se upisala.
            // Maloprodajna grana ispod je to vec radila ispravno.
            this.finalFromRight()
            this.marginFromRight()
          }
        }
        if (this.doRetail) {
          this.initPcs()
          this.initSupp()
          if (this.fullpriceChange) {
            // go normal from left to right
            this.marginFromLeft()
            this.finalFromLeft()
          }
          if (!this.fullpriceChange) {
            // calculate margin = iPrice - iSupp
            this.finalFromRight()
            this.marginFromRight()
          }
        }
      }
      if (this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3) {
        if (!this.doRetail) {
          this.initPcs()
          this.initBaseSupp()
          if (this.fullpriceChange) {
            // go normal from left to right
            this.finalFromLeft()
            this.profitSales()
          }
          if (!this.fullpriceChange) {
            // from right to left
            this.finalFromRight()
            this.profitSales()
          }
        }
        if (this.doRetail) {
          this.initPcs()
          this.initBaseSupp()
          if (this.fullpriceChange) {
            // go normal from left to right
            this.finalFromLeft()
            this.profitSales()
          }
          if (!this.fullpriceChange) {
            // from right to left
            this.finalFromRight()
            this.profitSales()
          }
        }
      }

    },
    initSupp() {
      this.initPcs()
      if (this.exportDoc) {
        if (this.$store.state.documentActiv === 'ReceiptPurchase') {
          const supp = (this.iSuppBaseForePrice ? this.iSuppBaseForePrice : 0) * (this.ExRate  ? this.ExRate  : 0)
          const deppendables = supp * (this.iSuppBasePercentageExp ? this.iSuppBasePercentageExp / 100 : 0)
          if ((supp + deppendables) !== 0) {
            this.iSuppBasePrice = supp + deppendables
            this.iDependablesAmount = deppendables * this.pcsLoc
          }
        }
        
        this.iSuppDiscount = this.iSuppDiscount ? this.iSuppDiscount : 0
        this.iSuppBasePriceAmount  = (this.iSuppBasePrice * this.pcsLoc) ? this.round((this.iSuppBasePrice * this.pcsLoc),2) : 0
        this.iSuppPriceAmount = (this.iSuppBasePriceAmount - (this.iSuppBasePriceAmount * (this.iSuppDiscount / 100))) ? this.round((this.iSuppBasePriceAmount - (this.iSuppBasePriceAmount * (this.iSuppDiscount / 100))),2) : 0
        this.iSuppDiscountAmount = (this.iSuppBasePriceAmount - this.iSuppPriceAmount) ? (this.iSuppBasePriceAmount - this.iSuppPriceAmount) : 0
      }
      if (!this.exportDoc) {
        this.iSuppBasePrice = this.iSuppBasePrice ? this.iSuppBasePrice : 0
        this.iSuppDiscount = this.iSuppDiscount ? this.iSuppDiscount : 0
        this.iSuppBasePriceAmount  = (this.iSuppBasePrice * this.pcsLoc) ? this.round((this.iSuppBasePrice * this.pcsLoc),2) : 0
        this.iSuppPriceAmount = (this.iSuppBasePriceAmount - (this.iSuppBasePriceAmount * (this.iSuppDiscount / 100))) ? this.round((this.iSuppBasePriceAmount - (this.iSuppBasePriceAmount * (this.iSuppDiscount / 100))),2) : 0
        this.iSuppDiscountAmount = (this.iSuppBasePriceAmount - this.iSuppPriceAmount) ? (this.iSuppBasePriceAmount - this.iSuppPriceAmount) : 0
      }
      if (this.pcsLoc !== 0) {
        this.iSuppPrice = (this.iSuppPriceAmount / this.pcsLoc) ? this.round((this.iSuppPriceAmount / this.pcsLoc),3) : 0
      }

    },
    initBaseSupp() {
      // ----------------------------------------------------------  >>>>>
      this.iSuppBasePrice = parseNum(this.iSuppPrice, 2)
      this.iSuppPrice = parseNum(this.iSuppPrice, 2)
      this.iSuppDiscount = 0
      this.iSuppDiscountAmount = 0
      this.iSuppBasePriceAmount  = (this.iSuppBasePrice * this.pcsLoc) ? this.round((this.iSuppBasePrice * this.pcsLoc),2) : 0
      this.iSuppPriceAmount  = this.iSuppBasePriceAmount
    },
    marginFromLeft() {
      this.iMarginAmount = 0
      if (this.iMargin !== 0) {
        this.iMarginAmount = this.round((this.iSuppPriceAmount * (this.iMargin / 100)),2)
      }
      this.iBaseAmount = this.round((this.iSuppPriceAmount  + this.iMarginAmount),2)
      this.iPrice = this.pcsLoc !== 0 ? this.round(this.iBaseAmount / this.pcsLoc, 2) : 0
      this.iFreeF2 = this.pcsLoc !== 0 ? this.round((this.iMarginAmount / this.pcsLoc),2) : 0
    },
    marginFromRight() {
      this.iMarginAmount = (this.iBaseAmount - this.iSuppPriceAmount) ? this.round((this.iBaseAmount - this.iSuppPriceAmount),2) : 0
      this.iMargin = 0
      if (this.iSuppPriceAmount !== 0) {
        this.iMargin = (this.iMarginAmount / (this.iSuppPriceAmount / 100)) ? this.round((this.iMarginAmount / (this.iSuppPriceAmount / 100)),2) : 0
      }
      this.iFreeF2 = (this.iMarginAmount / this.pcsLoc) ? this.round((this.iMarginAmount / this.pcsLoc),2) : 0
    },
    finalFromLeft() {
      if (!this.exportDoc || this.$store.state.documentActiv === 'ReceiptPurchase') {
        this.iDirectDuty1 = this.iDirectDuty1 ? this.round(this.iDirectDuty1, 2) : 0
        this.iVAT1Percentage = this.iVAT1Percentage ? this.round(this.iVAT1Percentage, 2) : 0
        if (this.ppo) {
          this.iVAT1Percentage = 0
        }
        this.iPrice = this.iPrice ? this.round((this.iPrice), 3) : 0

        this.iPriceOriginal = this.iPrice
        this.iFullPriceOriginal = this.round((this.iPrice * (1 + (this.iVAT1Percentage / 100))), 2)

        this.iBaseAmount = (this.iPrice * this.pcsLoc) ? (this.iPrice * this.pcsLoc) : 0
        this.iBaseAmount = this.round(this.iBaseAmount, 2)

        this.iDiscountAmount1 = this.iBaseAmount * (this.iDiscountPercentage1 / 100) ? this.iBaseAmount * (this.iDiscountPercentage1 / 100) : 0
        this.iDiscountAmount1 = this.round(this.iDiscountAmount1, 2)
        this.iBaseAmountNoVAT = this.iBaseAmount  - this.iDiscountAmount1
        this.iBaseAmountNoVAT = this.round(this.iBaseAmountNoVAT, 2)
        this.iDiscountPrice = this.iBaseAmountNoVAT && this.round(this.pcsLoc, 3) !== 0  ? this.round(this.iBaseAmountNoVAT / this.pcsLoc, 2)  : 0
        
        this.iAmountWithVAT = this.iBaseAmountNoVAT * (1 + (this.iVAT1Percentage / 100)) ? this.iBaseAmountNoVAT * (1 + (this.iVAT1Percentage / 100)) : 0
        this.iAmountWithVAT = this.round(this.iAmountWithVAT, 2)
        this.iVAT1Amount = this.iAmountWithVAT - this.iBaseAmountNoVAT
        this.iPriceWithVAT = this.iAmountWithVAT && this.round(this.pcsLoc, 3) !== 0  ? this.round(this.iAmountWithVAT / this.pcsLoc, 2)  : 0
        this.iDirectDuty1Amount = this.round((this.iDirectDuty1 * this.pcsLoc), 2)
        this.iFullTotal = (this.iAmountWithVAT + this.iDirectDuty1Amount)
        this.iFullTotal = this.round(this.iFullTotal, 2)
        // if is PPO, then there is no VAT
        if (this.$store.state.documentActivHead.PPO === true) {
          this.iAmountWithVAT = this.iBaseAmountNoVAT
          this.iAmountWithVAT = this.round(this.iAmountWithVAT, 2)
          this.iVAT1Percentage =  0
          this.iVAT1Amount = 0
          this.iPriceWithVAT = this.iAmountWithVAT && this.round(this.pcsLoc, 3) !== 0  ? this.round(this.iAmountWithVAT / this.pcsLoc, 2)  : 0
          this.iDirectDuty1Amount = this.round((this.iDirectDuty1 * this.pcsLoc), 2)
          this.iFullTotal = (this.iAmountWithVAT + this.iDirectDuty1Amount)
          this.iFullTotal = this.round(this.iFullTotal, 2)
          }
        // ako nije u sustavu PDVa
        if (this.$store.state.companyActiv.notinVAT === true) {
            this.iAmountWithVAT = this.iBaseAmountNoVAT
            this.iAmountWithVAT = this.round(this.iAmountWithVAT, 2)
            this.iVAT1Percentage =  0
            this.iVAT1Amount = 0
            this.iPriceWithVAT = this.iAmountWithVAT && this.round(this.pcsLoc, 3) !== 0  ? this.round(this.iAmountWithVAT / this.pcsLoc, 2)  : 0
            this.iDirectDuty1Amount = this.round((this.iDirectDuty1 * this.pcsLoc), 2)
            this.iFullTotal = (this.iAmountWithVAT + this.iDirectDuty1Amount)
            this.iFullTotal = this.round(this.iFullTotal, 2)
        }
        this.updateForeWithLocal()
      }
      if (this.exportDoc && this.$store.state.documentActiv !== 'ReceiptPurchase') {
        this.iForeDirectDuty1 = this.iForeDirectDuty1 ? this.round(this.iForeDirectDuty1, 2) : 0
        this.iForeVAT1Percentage = this.iForeVAT1Percentage ? this.round(this.iForeVAT1Percentage, 2) : 0

        this.iForePrice = this.iForePrice ? this.round(this.iForePrice, 3) : 0
        this.iBaseForeAmount = this.round((this.iForePrice * this.pcsLoc), 2)
        this.iBaseForeAmountNoVAT = (this.iBaseForeAmount - (this.iBaseForeAmount * (this.iDiscountPercentage1 / 100)))
        this.iBaseForeAmountNoVAT = this.round(this.iBaseForeAmountNoVAT, 2)
        if (this.pcsLoc !== 0) {
          this.iDiscountForePrice = (this.iBaseForeAmountNoVAT / this.pcsLoc)
          this.iDiscountForePrice = this.round(this.iDiscountForePrice, 2)
        }
        this.iForeVAT1Amount = ((this.iBaseForeAmountNoVAT * (this.iForeVAT1Percentage / 100)))
        this.iForeVAT1Amount = this.round(this.iForeVAT1Amount, 2)
        this.iForeAmountWithVAT = (parseFloat(this.iBaseForeAmountNoVAT) + parseFloat(this.iForeVAT1Amount))
        this.iForeAmountWithVAT = this.round(this.iForeAmountWithVAT, 2)
        this.maxDiscPer = (this.iForeAmountWithVAT / 100) ? this.round((this.iForeAmountWithVAT / 100),3) : 0
      // this.iMaxDiscount = ((this.iMarginAmount / this.maxDiscPer)) ? this.round(((this.iMarginAmount / this.maxDiscPer)),2) : 0
        if (this.pcsLoc !== 0) {
          this.iForePriceWithVAT = ((this.iForeAmountWithVAT / this.pcsLoc))
          this.iForePriceWithVAT = this.round(this.iForePriceWithVAT, 2)
        }
        this.iDirectDuty1AmountFore = this.round((this.iForeDirectDuty1 * this.pcsLoc), 2)
        this.iFullTotalFore = (this.iBaseForeAmountNoVAT + this.iForeVAT1Amount + this.iDirectDuty1AmountFore)
        this.iFullTotalFore = this.round(this.iFullTotalFore, 2)
        this.updateLocalWithFore()
      }
    },
    finalFromRight() {
      if (!this.exportDoc) {
        this.iDiscountAmount1 = 0
        this.homeDiscount = 0
        this.iDiscountPercentage1 = this.homeDiscount
        
        this.iDirectDuty1 = this.iDirectDuty1 ? this.round(this.iDirectDuty1, 2) : 0
        this.iVAT1Percentage = this.iVAT1Percentage ? this.round(this.iVAT1Percentage, 2) : 0
        if (this.ppo) {
          this.iVAT1Percentage = 0
        }
        this.iFullPriceOriginal = this.iPriceWithVAT ? this.round(this.iPriceWithVAT, 2) : 0

        this.iAmountWithVAT = this.iFullPriceOriginal * this.pcsLoc ? this.iFullPriceOriginal * this.pcsLoc : 0
        this.iAmountWithVAT = this.round(this.iAmountWithVAT, 2)
        this.iDirectDuty1Amount = this.round((this.iDirectDuty1 * this.pcsLoc), 2)
        this.iFullTotal = (this.iAmountWithVAT + this.iDirectDuty1Amount)
        this.iFullTotal = this.round(this.iFullTotal, 2)

        this.iBaseAmountNoVAT= this.iAmountWithVAT / (1 + (this.iVAT1Percentage / 100))
        this.iBaseAmountNoVAT = this.round((this.iBaseAmountNoVAT), 2)
        this.iBaseAmount = this.iBaseAmountNoVAT
        // Bez zaokruzivanja 12,99 - 10,39 daje 2,5999999999999996 i takav
        // iznos PDV-a zavrsi na stavci i u zbroju dokumenta.
        this.iVAT1Amount = this.round((this.iAmountWithVAT - this.iBaseAmountNoVAT), 2)
        this.iPrice = this.round((this.iBaseAmountNoVAT /this.pcsLoc) ,2)
        this.iDiscountPrice = this.iPrice

        this.updateForeWithLocal()
      }
      if (this.exportDoc) {
        this.iDiscountAmount1 = 0
        this.homeDiscount = 0
        this.iDiscountPercentage1 = this.homeDiscount
        this.iBaseAmount = this.iBaseAmountNoVAT

        this.iForeDirectDuty1 = this.iForeDirectDuty1 ? this.round(this.iForeDirectDuty1, 2) : 0
        this.iForeVAT1Percentage = this.iForeVAT1Percentage ? this.round(this.iForeVAT1Percentage, 2) : 0
        this.iForePriceWithVAT = this.round(this.iForePriceWithVAT, 2)

        this.iForeAmountWithVAT = this.iForePriceWithVAT * this.pcsLoc ? this.iForePriceWithVAT * this.pcsLoc : 0
        this.iForeAmountWithVAT = this.round(this.iForeAmountWithVAT, 2)

        this.iForeVAT1Amount = this.iForeAmountWithVAT - ((this.iForeAmountWithVAT / (1 + (this.iForeVAT1Percentage / 100))))
        this.iForeVAT1Amount = this.round(this.iForeVAT1Amount, 2)
        
        this.iBaseForeAmountNoVAT =  this.iForeAmountWithVAT - this.iForeVAT1Amount
        this.iBaseForeAmountNoVAT = this.round(this.iBaseForeAmountNoVAT, 2)
        this.iBaseForeAmount = this.iBaseForeAmountNoVAT
        
        if (this.pcsLoc !== 0) {
          this.iForePrice = (this.iBaseForeAmountNoVAT / this.pcsLoc)
          this.iDiscountForePrice = this.round(this.iForePrice, 2)
        }

        this.maxDiscPer = (this.iForeAmountWithVAT / 100) ? this.round((this.iForeAmountWithVAT / 100),3) : 0
        // this.iMaxDiscount = ((this.iMarginAmount / this.maxDiscPer)) ? this.round(((this.iMarginAmount / this.maxDiscPer)),2) : 0

        this.iDirectDuty1AmountFore = this.round((this.iForeDirectDuty1 * this.pcsLoc), 2)
        this.iFullTotalFore = (this.iBaseForeAmountNoVAT + this.iForeVAT1Amount + this.iDirectDuty1AmountFore)
        this.iFullTotalFore = this.round(this.iFullTotalFore, 2)
        //this.updateLocalWithFore()
      }

    },

    profitSales() {
      if (this.exportDoc) {
        this.iBaseAmountNoVAT = this.round(this.iBaseForeAmountNoVAT * this.ExRate, 2)
      }
      this.iMarginAmount = (this.iBaseAmountNoVAT - this.iSuppPriceAmount) ? this.round((this.iBaseAmountNoVAT - this.iSuppPriceAmount),2) : 0
      this.iMargin = 0
      if (this.iSuppPriceAmount !== 0) {
        this.iMargin = (this.iMarginAmount / (this.iSuppPriceAmount / 100)) ? this.round((this.iMarginAmount / (this.iSuppPriceAmount / 100)),2) : 0
      }  
      this.FreeF2 = (this.iMarginAmount / this.pcsLoc) ? this.round((this.iMarginAmount / this.pcsLoc),2) : 0 
    },
    calculateMarginSale() {
      this.initPcs()
      this.iSuppPriceAmount  = (this.iSuppPrice * this.pcsLoc) ? this.round((this.iSuppPrice * this.pcsLoc),2) : 0
      if (this.$store.state.companyActiv.CompanyUseRetailPrice) {
        this.iBaseAmount = this.round((this.iPrice * this.pcsLoc), 2)

        this.iMarginAmount = (this.iBaseAmount - this.iSuppPriceAmount) ? this.round((this.iBaseAmount - this.iSuppPriceAmount),2) : 0
        this.iMargin = 0
        if (this.iSuppPriceAmount !== 0) {
          this.iMargin = (this.iMarginAmount / (this.iSuppPriceAmount / 100)) ? this.round((this.iMarginAmount / (this.iSuppPriceAmount / 100)),2) : 0
        }
        
        this.FreeF2 = (this.iMarginAmount / this.pcsLoc) ? this.round((this.iMarginAmount / this.pcsLoc),2) : 0 
      }
    },
    updateLocalWithFore() {
      this.iPrice = this.iForePrice ? this.round(this.iForePrice * this.ExRate, 3) : 0
      this.iBaseAmount = this.round((this.iBaseForeAmount * this.ExRate), 2)
      this.iBaseAmountNoVAT = this.round(this.iBaseForeAmountNoVAT * this.ExRate, 2)
      this.iDiscountPrice = this.round(this.iDiscountForePrice * this.ExRate, 2)
      this.iVAT1Amount = this.round(this.iForeVAT1Amount * this.ExRate, 2)
      this.iAmountWithVAT = this.round(this.iForeAmountWithVAT * this.ExRate, 2)
      this.iPriceWithVAT = this.round(this.iForePriceWithVAT * this.ExRate, 2)
      this.iDirectDuty1Amount = this.round((this.iDirectDuty1Amount * this.ExRate), 2)
      this.iFullTotal = this.round(this.iFullTotalFore * this.ExRate, 2) 
    },
    updateForeWithLocal(){
      this.iForePrice = this.round(this.iPrice / this.ExRate, 2)
      this.iForeVAT1Percentage = this.iVAT1Percentage
      this.iForeVAT1Amount = this.round(this.iVAT1Amount / this.ExRate, 2)
      this.iForeVAT2Percentage = this.iVAT2Percentge
      this.iForeVAT2Amount = this.round(this.iVAT2Amount / this.ExRate, 2)
      this.iForeDirectDuty1 = this.round(this.iDirectDuty1 / this.ExRate, 2)
      this.iForeDirectDuty2 = this.round(this.iDirectDuty2 / this.ExRate, 2)
      this.iForePriceWithVAT = this.round(this.iPriceWithVAT / this.ExRate, 2)
    },
    makeItNew(){
      this.clearIt()
      this.documentDet = defDocumentDetail()
      this.documentDet = {...this.documentDet, ...defNewDocumentDetail()}
      const newId = this.getRndInteger(1000000000, 9000000000)
      this.documentDet.id = newId
      this.$store.dispatch('setDocumentDetailid', newId)
      if (this.$store.state.documentSide === 1) {
        this.iPcsPlus = 1
      }
      if (this.$store.state.documentSide === 2) {
        this.iPcsMinus = 1
      }
      if (this.$store.state.documentSide === 3) {
        this.iPcsNeutral = 1
      }
      this.initPcs()
    },
    findItem () {
       if (this.newItem) {
        this.mainQuery2 = {...this.emptyObj}
        this.mainQuery2.CompanyId = this.$store.state.companyid
        this.mainQuery2.itemID = this.selectIL.itemID ? this.selectIL.itemID : null
        // const myObjStr = JSON.stringify(this.mainQuery2)
        this.findIt()
       }
    },
    clearIt() {
      this.$store.dispatch('setItemActiv', {})
      this.iID = ''
      this.iName = ''
      this.iNameShort = ''
      this.iCode = ''
      this.iEANCode = ''
      this.iGroup = ''
      this.iGroupName = ''
      this.iForceNewPrintPage = false
      this.iDescription = ''
      this.iUnit = ''
      this.iSize = ''
      this.iWeight = 0
      this.iWeightMeasure = ''
      this.iDimMeasure = ''
      this.iDimLenght = 0
      this.iDimHeight = 0
      this.iDimDepth = 0
      this.iWarehouse = ''
      this.iWarehouseRow = ''
      this.iWarehouseShelf = ''
      this.iWahrehouseFloor = ''
      this.iPicture1 = ''
      this.iPicture2 = ''
      this.iPicture3 = ''
      this.iPicture4 = ''
      this.iPicture5 = ''
      this.iPicture6 = ''
      this.iPicture7 = ''
      this.iDefaultPicture = null
      this.iBelongsToId = 0
      this.iService = false
      this.iWeb = false
      this.iNotActiv = false
      this.iHideForever = false
      this.iHomeCurrency = ''
      this.iForeignCurrency = ''
      this.iExRate = 0
      this.iTransport = 0
      this.iTransportAmount = 0
      this.iCustom = 0
      this.iCustomAmount = 0
      this.iDependables = 0
      this.iDependablesAmount = 0
      this.iSuppBaseForePrice = 0
      this.iSuppBasePercentageExp = 0
      this.iSuppBaseForePrice2 = 0
      this.iSuppBaseForeAmount = 0
      this.iSuppBasePrice = 0
      this.iSuppBasePriceAmount = 0
      this.iSuppDiscount = 0
      this.iSuppDiscountAmount = 0
      this.iSuppPrice = 0
      this.iSuppPriceAmount = 0
      this.iSuppCode = ''
      this.iMargin = 0
      this.iMarginAmount = 0
      this.iMaxDiscount = 0
      this.iPrice = 0
      this.iVAT1Percentage = 0
      this.iVAT1Amount = 0
      this.iVAT2Percentge = 0
      this.iVAT2Amount = 0
      this.iDirectDuty1 = 0
      this.iDirectDuty2 = 0
      this.iPriceWithVAT = 0
      this.iForePrice = 0
      this.iForeVAT1Percentage = 0
      this.iForeVAT1Amount = 0
      this.iForeVAT2Percentage = 0
      this.iForeVAT2Amount = 0
      this.iForeDirectDuty1 = 0
      this.iForeDirectDuty2 = 0
      this.iForePriceWithVAT = 0
      this.iBaseAmount = 0
      this.iBaseForeAmount = 0
      this.iDiscountAmount1 = 0
      this.iDiscountForeAmount1 = 0
      this.iDiscountPercentage1 = 0
      this.iDiscountAmount2 = 0
      this.iDiscountPercentage2 = 0
      this.iDiscountAmount3 = 0
      this.iDiscountPercentage4 = 0
      this.iDiscountPrice = 0
      this.iDiscountForePrice = 0
      this.iSerialNr = ''
      this.iPcsPlus = 0
      this.iPcsMinus = 0
      this.iPcsNeutral = 0
      this.iBaseAmountNoVAT = 0
      this.iBaseForeAmountNoVAT = 0
      this.iBaseAmountWithVAT = 0
      this.iBaseForeAmountWithVAT = 0
      this.iAmountWithVAT = 0
      this.iFullTotal = 0
      this.iFullTotalFore = 0
      this.iForeAmountWithVAT = 0
      this.iDirectDuty1Amount = 0
      this.iDirectDuty2Amount = 0
      this.iDirectDuty1AmountFore = 0
      this.iDirectDuty2AmountFore = 0
      this.niPrice = 0
      this.niBaseAmount = 0
      this.niVAT1Percentage = 0
      this.niVAT1Amount = 0
      this.niAmountWithVAT = 0
      this.niDirectDuty1 = 0
      this.niFullTotal = 0
      this.iexportDoc = false
      this.iPriceOriginal = 0
      this.iFullPriceOriginal = 0
      this.iFreeF1 = 0
      this.iFreeF2 = 0
      this.iFreeF3 = 0
      this.iFreeF4 = 0
      this.iFreeF5 = 0
      this.iFreeF6 = 0
      this.iTypeID = 0
      this.iTypeName = ''
    },
    unassignIt() {
      this.documentDet.itemID = this.iID
      this.documentDet.itemName = this.iName
      this.documentDet.ItemNameShort = this.iNameShort
      this.documentDet.ItemCode = this.iCode
      this.documentDet.ItemEANCode = this.iEANCode
      this.documentDet.itemGroup = this.iGroup
      this.documentDet.itemGroupName = this.iGroupName
      this.documentDet.forceNewPrintPage = this.iForceNewPrintPage
      this.documentDet.itemDescription = this.iDescription
      this.documentDet.itemUnit = this.iUnit
      this.documentDet.ItemSize = this.iSize
      this.documentDet.ItemWeight = this.iWeight
      this.documentDet.ItemWeightMeasure = this.iWeightMeasure
      this.documentDet.ItemDimMeasure = this.iDimMeasure
      this.documentDet.ItemDimLenght = this.iDimLenght
      this.documentDet.ItemDimHeight = this.iDimHeight
      this.documentDet.ItemDimDepth = this.iDimDepth
      this.documentDet.ItemWarehouse = this.iWarehouse
      this.documentDet.ItemWarehouseRow = this.iWarehouseRow
      this.documentDet.ItemWarehouseShelf = this.iWarehouseShelf
      this.documentDet.ItemWahrehouseFloor = this.iWahrehouseFloor
      this.documentDet.ItemPicture1 = this.iPicture1
      this.documentDet.ItemPicture2 = this.iPicture2
      this.documentDet.ItemPicture3 = this.iPicture3
      this.documentDet.ItemPicture4 = this.iPicture4
      this.documentDet.ItemPicture5 = this.iPicture5
      this.documentDet.ItemPicture6 = this.iPicture6
      this.documentDet.ItemPicture7 = this.iPicture7
      this.documentDet.ItemDefaultPicture = this.iDefaultPicture
      this.documentDet.ItemBelongsToId = this.iBelongsToId
      this.documentDet.itemService = this.iService
      this.documentDet.itemWeb = this.iWeb
      this.documentDet.itemNotActiv = this.iNotActiv
      this.documentDet.itemHideForever = this.iHideForever
      this.documentDet.ItemHomeCurrency = this.iHomeCurrency
      this.documentDet.ItemForeignCurrency = this.iForeignCurrency
      this.documentDet.ItemExRate = this.ExRate
      this.documentDet.itemTransport = this.iTransport
      this.documentDet.itemTransportAmount = this.iTransportAmount
      this.documentDet.itemCustom = this.iCustom
      this.documentDet.itemCustomAmount = this.iCustomAmount
      this.documentDet.itemDependables = this.iDependables
      this.documentDet.itemDependablesAmount = this.iDependablesAmount
      this.documentDet.itemSuppBaseForePrice = this.iSuppBaseForePrice
      this.documentDet.itemSuppBasePercentageExp = this.iSuppBasePercentageExp
      this.documentDet.itemSuppBaseForePrice2 = this.iSuppBaseForePrice2
      this.documentDet.itemSuppBaseForeAmount = this.iSuppBaseForeAmount
      this.documentDet.itemSuppBasePrice = this.iSuppBasePrice
      this.documentDet.itemSuppBasePriceAmount = this.iSuppBasePriceAmount
      this.documentDet.itemSuppDiscount = this.iSuppDiscount
      this.documentDet.itemSuppDiscountAmount = this.iSuppDiscountAmount
      this.documentDet.itemSuppPrice = this.iSuppPrice
      this.documentDet.itemSuppPriceAmount = this.iSuppPriceAmount
      this.documentDet.ItemSuppCode = this.iSuppCode
      this.documentDet.itemMargin = this.iMargin
      this.documentDet.itemMarginAmount = this.iMarginAmount
      this.documentDet.itemMaxDiscount = this.iMaxDiscount
      this.documentDet.itemPrice = this.iPrice
      this.documentDet.itemVAT1Percentage = this.iVAT1Percentage
      this.documentDet.itemVAT1Amount = this.iVAT1Amount
      this.documentDet.itemVAT2Percentge = this.iVAT2Percentge
      this.documentDet.itemVAT2Amount = this.iVAT2Amount
      this.documentDet.itemDirectDuty1 = this.iDirectDuty1
      this.documentDet.itemDirectDuty2 = this.iDirectDuty2
      this.documentDet.itemPriceWithVAT = this.iPriceWithVAT
      this.documentDet.itemForePrice = this.iForePrice
      this.documentDet.itemForeVAT1Percentage = this.iForeVAT1Percentage
      this.documentDet.itemForeVAT1Amount = this.iForeVAT1Amount
      this.documentDet.itemForeVAT2Percentage = this.iForeVAT2Percentage
      this.documentDet.itemForeVAT2Amount = this.iForeVAT2Amount
      this.documentDet.itemForeDirectDuty1 = this.iForeDirectDuty1
      this.documentDet.itemForeDirectDuty2 = this.iForeDirectDuty2 
      this.documentDet.itemForePriceWithVAT = this.iForePriceWithVAT
      this.documentDet.itemBaseAmount = this.iBaseAmount 
      this.documentDet.itemBaseForeAmount = this.iBaseForeAmount
      this.documentDet.itemDiscountAmount1 = this.iDiscountAmount1
      this.documentDet.itemDiscountForeAmount1 = this.iDiscountForeAmount1
      this.documentDet.itemDiscountPercentage1 = this.iDiscountPercentage1
      this.documentDet.itemDiscountAmount2 = this.iDiscountAmount2
      this.documentDet.itemDiscountPercentage2 = this.iDiscountPercentage2
      this.documentDet.itemDiscountAmount3 = this.iDiscountAmount3
      this.documentDet.itemDiscountPercentage4 = this.iDiscountPercentage4
      this.documentDet.itemDiscountPrice = this.iDiscountPrice
      this.documentDet.itemDiscountForePrice = this.iDiscountForePrice
      this.documentDet.itemSerialNr = this.iSerialNr
      this.documentDet.itemPcsPlus = this.iPcsPlus
      this.documentDet.itemPcsMinus = this.iPcsMinus
      this.documentDet.itemPcsNeutral = this.iPcsNeutral
      this.documentDet.itemBaseAmountNoVAT = this.iBaseAmountNoVAT
      this.documentDet.itemBaseForeAmountNoVAT = this.iBaseForeAmountNoVAT
      this.documentDet.itemBaseAmountWithVAT = this.iBaseAmountWithVAT
      this.documentDet.itemBaseForeAmountWithVAT = this.iBaseForeAmountWithVAT
      this.documentDet.itemAmountWithVAT = this.iAmountWithVAT
      this.documentDet.itemFullTotal = this.iFullTotal
      this.documentDet.itemFullTotalFore = this.iFullTotalFore
      this.documentDet.itemForeAmountWithVAT = this.iForeAmountWithVAT
      this.documentDet.itemDirectDuty1Amount = this.iDirectDuty1Amount
      this.documentDet.itemDirectDuty2Amount = this.iDirectDuty2Amount
      this.documentDet.itemDirectDuty1AmountFore = this.iDirectDuty1AmountFore
      this.documentDet.itemDirectDuty2AmountFore = this.iDirectDuty2AmountFore
      this.documentDet.newitemPrice = this.niPrice
      this.documentDet.newitemBaseAmount = this.niBaseAmount
      this.documentDet.newitemVAT1Percentage = this.niVAT1Percentage
      this.documentDet.newitemVAT1Amount = this.niVAT1Amount
      this.documentDet.newitemAmountWithVAT = this.niAmountWithVAT
      this.documentDet.newitemDirectDuty1 = this.niDirectDuty1
      this.documentDet.newitemFullTotal = this.niFullTotal
      this.documentDet.exportDoc = this.exportDoc
      this.documentDet.itemPriceOriginal = this.iPriceOriginal
      this.documentDet.itemFullPriceOriginal = this.iFullPriceOriginal
      this.documentDet.FreeF1 = this.iFreeF1
      this.documentDet.FreeF2 = this.iFreeF2
      this.documentDet.FreeF3 = this.iFreeF3
      this.documentDet.FreeF4 = this.iFreeF4
      this.documentDet.FreeF5 = this.iFreeF5
      this.documentDet.FreeF6 = this.iFreeF6
      this.documentDet.TypeID = this.iTypeID
      this.documentDet.TypeName = this.iTypeName
      this.documentDet.TaxExemptionReason = this.iTaxExemptionReason 
      this.documentDet.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
    },
    assignIt(itm, type) {
      if (itm) {
        console.log('assignIT  type', type, 'itm.GroupId ', itm.GroupId , 'itm.itemGroup', itm.itemGroup, 'itm', itm)
         console.log('assignIT this.selectIL: ', this.selectIL, !this.selectIL, Object.keys(this.selectIL).length);
        if (!this.selectIL || Object.keys(this.selectIL).length === 0) {
          this.componentKey += 1
          this.selectIL =
          {
            itemByID: (itm.itemID + ' ' + itm.itemName),
            itemID: itm.itemID,
            key: this.componentKey
          }
        }
       
        this.haveItemSelected = true
        this.iID = itm.itemID
        this.iName = itm.itemName
        this.iNameShort = itm.ItemNameShort
        this.iCode = itm.ItemCode
        this.iEANCode = itm.ItemEANCode
        if (itm.GroupId) {
          this.iGroup = type === 1 ? itm.GroupId : itm.itemGroup
        }
        if (itm.itemGroup) {
          this.iGroup = type === 1 ? itm.GroupId : itm.itemGroup
        }

        this.iGroupName = itm.GroupName ? itm.GroupName : ''
        this.iForceNewPrintPage = itm.forceNewPrintPage
        this.iDescription = itm.itemDescription
        this.iUnit = itm.itemUnit
        this.iSize = parseNum(itm.ItemSize, 2)
        this.iWeight = itm.ItemWeight
        this.iWeightMeasure = itm.ItemWeightMeasure
        this.iDimMeasure = itm.ItemDimMeasure
        this.iDimLenght = itm.ItemDimLenght
        this.iDimHeight = itm.ItemDimHeight
        this.iDimDepth = itm.ItemDimDepth
        this.iWarehouse = itm.ItemWarehouse
        this.iWarehouseRow = itm.ItemWarehouseRow
        this.iWarehouseShelf = itm.ItemWarehouseShelf
        this.iWahrehouseFloor = itm.ItemWahrehouseFloor
        this.iPicture1 = itm.ItemPicture1
        this.iPicture2 = itm.ItemPicture2
        this.iPicture3 = itm.ItemPicture3
        this.iPicture4 = itm.ItemPicture4
        this.iPicture5 = itm.ItemPicture5
        this.iPicture6 = itm.ItemPicture6
        this.iPicture7 = itm.ItemPicture7
        this.iDefaultPicture = itm.ItemDefaultPicture ? itm.ItemDefaultPicture : null
        this.iBelongsToId = itm.ItemBelongsToId
        this.iService = itm.itemService
        this.iWeb = itm.itemWeb
        this.iNotActiv = itm.itemNotActiv
        this.iHideForever = itm.itemHideForever

        this.iHomeCurrency = itm.ItemHomeCurrency
        this.iForeignCurrency = itm.ItemForeignCurrency
        //this.iExRate = parseNum(itm.ItemExRate, 2)
        this.iTransport = parseNum(itm.itemTransport, 2)
        this.iTransportAmount = parseNum(itm.itemTransportAmount, 2)
        this.iCustom = parseNum(itm.itemCustom, 2)
        this.iCustomAmount = parseNum(itm.itemCustomAmount, 2)
        this.iDependables = parseNum(itm.itemDependables, 2)
        this.iDependablesAmount = parseNum(itm.itemDependablesAmount, 2)
        this.iSuppBaseForePrice = parseNum(itm.itemSuppBaseForePrice, 2)
        //this.iSuppBasePercentageExp = parseNum(itm.itemSuppBasePercentageExp, 2)
        this.iSuppBaseForePrice2 = parseNum(itm.itemSuppBaseForePrice2, 2)
        this.iSuppBaseForeAmount = parseNum(itm.itemSuppBaseForeAmount, 2)
        this.iSuppBasePrice = parseNum(itm.itemSuppBasePrice, 2)
        this.iSuppBasePriceAmount = parseNum(itm.itemSuppBasePriceAmount, 2)
        this.iSuppDiscount = parseNum(itm.itemSuppDiscount, 2)
        this.iSuppDiscountAmount = parseNum(itm.itemSuppDiscountAmount, 2)
        this.iSuppPrice = parseNum(itm.itemSuppPrice, 2)
        this.iSuppPriceAmount = parseNum(itm.itemSuppPriceAmount, 2)
        this.iSuppCode = itm.ItemSuppCode
        this.iMargin = parseNum(itm.itemMargin, 2)
        this.iMarginAmount = parseNum(itm.itemMarginAmount, 2)
        this.iMaxDiscount = parseNum(itm.itemMaxDiscount, 2)
        this.iPrice = parseNum(itm.itemPrice, 2)
        this.iVAT1Percentage = parseNum(itm.itemVAT1Percentage, 2)
        this.iVAT1Amount = parseNum(itm.itemVAT1Amount, 2)
        this.iVAT2Percentge = parseNum(itm.itemVAT2Percentge, 2)
        this.iVAT2Amount = parseNum(itm.itemVAT2Amount, 2)
        this.iDirectDuty1 = parseNum(itm.itemDirectDuty1, 2)
        this.iDirectDuty2 = parseNum(itm.itemDirectDuty2, 2)
        this.iPriceWithVAT = parseNum(itm.itemPriceWithVAT, 2)
        this.iForePrice = parseNum(itm.itemForePrice, 2)
        this.iForeVAT1Percentage = parseNum(itm.itemForeVAT1Percentage, 2)
        this.iForeVAT1Amount = parseNum(itm.itemForeVAT1Amount, 2)
        this.iForeVAT2Percentage = parseNum(itm.itemForeVAT2Percentage, 2)
        this.iForeVAT2Amount = parseNum(itm.itemForeVAT2Amount, 2)
        this.iForeDirectDuty1 = parseNum(itm.itemForeDirectDuty1, 2)
        this.iForeDirectDuty2 = parseNum(itm.itemForeDirectDuty2, 2)
        this.iForePriceWithVAT = parseNum(itm.itemForePriceWithVAT, 2)
        this.iBaseAmount = parseNum(itm.itemBaseAmount, 2)
        this.iBaseForeAmount = parseNum(itm.itemBaseForeAmount, 2)
        this.iDiscountAmount1 = parseNum(itm.itemDiscountAmount1, 2)
        this.iDiscountForeAmount1 = parseNum(itm.itemDiscountForeAmount1, 2)
        this.iDiscountPercentage1 = parseNum(itm.itemDiscountPercentage1, 2)
        this.iDiscountAmount2 = parseNum(itm.itemDiscountAmount2, 2)
        this.iDiscountPercentage2 = parseNum(itm.itemDiscountPercentage2, 2)
        this.iDiscountAmount3 = parseNum(itm.itemDiscountAmount3, 2)
        this.iDiscountPercentage4 = parseNum(itm.itemDiscountPercentage4, 2)
        this.iDiscountPrice = parseNum(itm.itemDiscountPrice, 2)
        this.iDiscountForePrice = parseNum(itm.itemDiscountForePrice, 2)
        this.iSerialNr = itm.itemSerialNr
        // Kolicina se i kod otvaranja postojece stavke cita na 3 decimale -
        // inace bi se upisanih 12,345 t pri svakom ispravku stavke pretvorilo
        // u 12,35 t i tiho promijenilo iznos.
        this.iPcsPlus = parseNum(itm.itemPcsPlus, 3)
        this.iPcsMinus = parseNum(itm.itemPcsMinus, 3)
        this.iPcsNeutral = parseNum(itm.itemPcsNeutral, 3)
        this.iBaseAmountNoVAT = parseNum(itm.itemBaseAmountNoVAT, 2)
        this.iBaseForeAmountNoVAT = parseNum(itm.itemBaseForeAmountNoVAT, 2)
        this.iBaseAmountWithVAT = parseNum(itm.itemBaseAmountWithVAT, 2)
        this.iBaseForeAmountWithVAT = parseNum(itm.itemBaseForeAmountWithVAT, 2)
        this.iAmountWithVAT = parseNum(itm.itemAmountWithVAT, 2)
        this.iFullTotal = parseNum(itm.itemFullTotal, 2)
        this.iFullTotalFore = parseNum(itm.itemFullTotalFore, 2)
        this.iForeAmountWithVAT = parseNum(itm.itemForeAmountWithVAT, 2)
        this.iDirectDuty1Amount = parseNum(itm.itemDirectDuty1Amount, 2)
        this.iDirectDuty2Amount = parseNum(itm.itemDirectDuty2Amount, 2)
        this.iDirectDuty1AmountFore = parseNum(itm.itemDirectDuty1AmountFore, 2)
        this.iDirectDuty2AmountFore = parseNum(itm.itemDirectDuty2AmountFore, 2)
        this.niPrice = parseNum(itm.newitemPrice, 2)
        this.niBaseAmount = parseNum(itm.newitemBaseAmount, 2)
        this.niVAT1Percentage = parseNum(itm.newitemVAT1Percentage, 2)
        this.niVAT1Amount = parseNum(itm.newitemVAT1Amount, 2)
        this.niAmountWithVAT = parseNum(itm.newitemAmountWithVAT, 2)
        this.niDirectDuty1 = parseNum(itm.newitemDirectDuty1, 2)
        this.niFullTotal = parseNum(itm.newitemFullTotal, 2)
        this.iexportDoc = this.exportDoc
        this.iPriceOriginal = parseNum(itm.itemPrice, 2)
        this.iFullPriceOriginal = parseNum(itm.itemPriceWithVAT, 2)
        this.iFreeF1 = parseNum(itm.FreeF1, 2)
        this.iFreeF2 = parseNum(itm.FreeF2, 2)
        this.iFreeF3 = parseNum(itm.FreeF3, 2)
        this.iFreeF4 = parseNum(itm.FreeF4, 2)
        this.iFreeF5 = parseNum(itm.FreeF5, 2)
        this.iFreeF6 = parseNum(itm.FreeF6, 2)
        this.iTypeID = parseNum(itm.TypeID, 2)
        this.iTypeName = itm.TypeName
        this.documentDet.PotpunaSifra = itm.PotpunaSifra
        const result2 = this.$store.state.klasus.filter(element => element.PotpunaSifra === itm.PotpunaSifra)
        if (result2[0]) {
          this.selectKlasus = result2[0]
        }

        if (this.iSuppBasePrice === 0 && this.iPrice !== 0) {
          this.iSuppBasePrice = this.iPrice
          this.iSuppPrice = this.iPrice
        }

        if (this.iSuppBaseForePrice === 0 && this.iSuppBasePrice !== 0) {
          this.iSuppBaseForePrice = parseNum((this.iSuppBasePrice / (this.ExRate  ? this.ExRate  : 1)), 2)
        }

        // if (this.$store.state.documentActiv === 'ReceiptPurchase') {
        //   this.infoSuppBaseForePrice = parseNum(itm.itemSuppBaseForePrice, 2)
        //   this.infoSuppBasePrice = parseNum(itm.itemSuppBasePrice, 2)
        //   this.infoSuppDiscount = parseNum(itm.itemSuppDiscount, 2)
        //   this.infoSuppPrice = parseNum(itm.itemSuppPrice, 2)
        //   this.infoMargin = parseNum(itm.itemMargin, 2)
        // }
        // new item, from item database
        if (type === 1) {
          if (this.$store.state.companyActiv.CompanyUseRetailPrice === true) {
           
            this.iPrice = this.iPriceWithVAT / (1 + (this.iVAT1Percentage / 100))
            this.iPrice = this.iPrice ? this.round(this.iPrice, 2) : 0
          }

          // if local doc, then local multiplay fore with exrate, if is fore then (1.if have fore price, use it, or 2. if dont have fore price, use local and divde with exrate)
          if (this.exportDoc === false) {
            
            this.iPriceOriginal = this.iPrice
            this.iFullPriceOriginal = this.iPriceWithVAT
            this.updateForeWithLocal()

          }
          if (this.exportDoc === true) {
            if (this.$store.state.documentActiv !== 'ReceiptPurchase') {
              // if have fore price use it, if dont have fore price use local price and do math with exrate
              if (this.iForePrice && this.iForePrice > 0) {
                this.updateLocalWithFore()

              } else {
                  this.iVAT1Percentage = 0
                  this.iVAT1Amount = 0
                  this.iVAT2Percentge = 0
                  this.iVAT2Amount = 0
                  this.iDirectDuty1 = 0
                  this.iPriceOriginal = this.round(this.iPrice / this.ExRate, 2)
                  this.iFullPriceOriginal = this.round(this.iPrice / this.ExRate, 2)
                  this.iForePrice = this.round(this.iPrice / this.ExRate, 2)
                  this.iForeVAT1Percentage = 0
                  this.iForeVAT1Amount = 0
                  this.iForeVAT2Percentage = 0
                  this.iForeVAT2Amount = 0
                  this.iForeDirectDuty1 = 0
                  this.iForeDirectDuty2 = 0
                  this.iForePriceWithVAT = this.round(this.iPrice / this.ExRate, 2)
              }
            } 
            if (this.$store.state.documentActiv === 'ReceiptPurchase') {
              this.updateForeWithLocal()
            }
            this.iSuppBasePercentageExp = this.$store.state.documentActivHead.expenesPercent && parseFloat(this.$store.state.documentActivHead.expenesPercent) > 0 ? parseFloat(this.$store.state.documentActivHead.expenesPercent) : 0
            this.iExRate = this.ExRate
          }

          // Popust se uvijek daje od cijene bez PDV-a, pa i kad firma radi s
          // maloprodajnim cijenama; prije se tu dijelilo cijenom s PDV-om.
          this.iMaxDiscount = maxPopust(this.iPrice, this.iSuppPrice)
          
          this.iDiscountPercentage1 = 0
        }

      }
    },
    async findIt () {
      try {
        console.log('FindIT NORMAL this.mainQuery2', this.mainQuery2, 'this.selectIL', this.selectIL)
        const {data} = await ItemService.choose(this.mainQuery2)
        if (data && data.item !== undefined) {
          this.$store.dispatch('setItemid', data.item.id)
          this.$store.dispatch('setItemActiv', data.item)
          this.assignIt(data.item, 1)
          this.inputDocCalc()
          this.setKategorije()
          if (this.newItemCreate) {
            this.newItemCreate = false
          }
          // this.calculatePrice()
        }
      } catch (error) {
        this.error = ' Greska Ne mogu naci artikla'
        this.typeError = 'error'
        // eslint-disable-next-line
        console.log(' greska Ne mogu naci artikla', error)
      }
    },
    async findItBasic (query) {
      try {

        const {data} = await ItemService.choose(query)
        if (data && data.item !== undefined) {
          if (data.item.id) {
            if (!this.selectIL || Object.keys(this.selectIL).length === 0) {
              this.componentKey += 1
              this.selectIL =
              {
                itemByID: (data.item.itemID + ' ' + data.item.itemName),
                itemID: data.item.itemID,
                key: this.componentKey
              }
            }
            this.iID = data.item.itemID
            this.iGroup = data.item.GroupId  ? data.item.GroupId : ''
            this.iGroupName = data.item.GroupName ? data.item.GroupName : ''
            this.iUnit = data.item.itemUnit ? data.item.itemUnit : ''
            // Slike prate sifru: kad se na stavci promijeni artikl, ne smije
            // ostati slika prethodnog. Cijene se namjerno ne diraju.
            for (let br = 1; br <= 7; br++) {
              this['iPicture' + br] = data.item['ItemPicture' + br] ? data.item['ItemPicture' + br] : ''
            }
            this.iDefaultPicture = data.item.ItemDefaultPicture ? data.item.ItemDefaultPicture : null
            this.documentDet.itemID = data.item.itemID
            this.documentDet.itemGroup = this.iGroup
            this.documentDet.itemGroupName = this.iGroupName
            this.documentDet.itemUnit = this.iUnit
            this.haveItemSelected = true
          }
          this.$store.dispatch('setItemid', data.item.id)
          this.$store.dispatch('setItemActiv', this.documentDet)
          this.setKategorije()
          if (this.showConditionGroup) {
            this.showConditionGroup = false
          }
          if (this.newItemCreate) {
            this.newItemCreate = false
          }
          // this.calculatePrice()
        }
      } catch (error) {
        this.error = ' Greska Ne mogu naci artikla'
        this.typeError = 'error'
        // eslint-disable-next-line
        console.log(' greska Ne mogu naci artikla', error)
      }
    },
    setKategorije() {
      let uv = null
      if (this.iVAT1Percentage === 25) {uv = 1}
      if (this.iVAT1Percentage === 13) {uv = 2}
      if (this.iVAT1Percentage === 5) {uv = 3}
      if (this.iVAT1Percentage === 0) {uv = 4}
      // ako je dokument oznacen kao ino 
      if (this.$store.state.documentActivHead.exportDoc) {uv = 5 }
      // ako je dokument oznacen kao ppo
      if (this.$store.state.documentActivHead.PPO) {uv = 7 }
      if (this.$store.state.companyActiv.notinVAT === true) {uv = 13}
      const result = this.$store.state.OznakaKategorijePDV.filter(element => element.id === uv)
      if (result[0]) {
        const res = result[0]
        this.documentDet.kod = res.value
        this.documentDet.kodKategorije  = res.kodKategorije
        this.documentDet.kodSheme = res.kodSheme
        this.selectKategorije = res
      }
    },
    makeSum() {
      const updateSumObject = {
        documentDescription9: 0,
        documentDescription10: 0,
        documentTotalVAT1Per: 0,
        documentTotalVAT1Base: 0,
        documentTotalVAT1Amount: 0,
        documentTotalVAT2Per: 0,
        documentTotalVAT2Base: 0,
        documentTotalVAT2Amount: 0,
        documentTotalVAT3Per: 0,
        documentTotalVAT3Base: 0,
        documentTotalVAT3Amount: 0,
        documentTotalVAT4Per: 0,
        documentTotalVAT4Base: 0,
        documentTotalVAT4Amount: 0,
        documentTotalVAT5Per: 0,
        documentTotalVAT5Base: 0,
        documentTotalVAT5Amount: 0,
        documentTotalAmountNetto: 0,
        documentTotalAmountVAT: 0,
        documentTotalAmountBrutto: 0,
        documentTotalAmountPayInAdvance: this.$store.state.documentActivHead.documentTotalAmountPayInAdvance ? parseFloat(this.$store.state.documentActivHead.documentTotalAmountPayInAdvance) : 0,
        documentTotalAmountToPay: 0,
        documentTotalAmountNettoForeign: 0,
        documentTotalAmountVATForeign: 0,
        documentTotalAmountBruttoForeign: 0,
        documentTotalAmountPayInAdvanceForeign: 0,
        documentTotalAmountToPayForeign: 0,
        documentTotalAmountDirectD1: 0,
        documentTotalAmountDirectD2: 0,
        documentTotalAmountDirectD1Fore: 0,
        documentTotalAmountDirectD2Fore: 0,
        supplierAmount: 0,
        supplierNetoAmount: 0,
        supplierDiscount: 0,
        supplierMargin: 0,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
      }
      let dSide = 3
      if (this.$store.state.documentSide) {
        dSide = this.$store.state.documentSide
      }

      const hrVat1 = 25
      const hrVat2 = 13
      const hrVat3 = 5
      const documentsDet = this.$store.state.documentActivItems ? this.$store.state.documentActivItems : []
      if (documentsDet) {
        documentsDet.map(documentDet => {

          this.pcsLoc = 0
          if (dSide === 1 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsPlus) ? parseFloat(documentDet.itemPcsPlus)  : 0
          }
          if (dSide === 2 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsMinus) ? parseFloat(documentDet.itemPcsMinus)  : 0
          }
          if (dSide === 3 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsNeutral) ? parseFloat(documentDet.itemPcsNeutral)  : 0
          }
          this.pcsLoc = this.round(this.pcsLoc, 3)     
          
          if ((documentDet.itemSuppBasePriceAmount)) {
            updateSumObject.supplierAmount += this.round((documentDet.itemSuppBasePriceAmount),2)
          }
          if (documentDet.itemSuppDiscountAmount) {
            updateSumObject.supplierDiscount += this.round(documentDet.itemSuppDiscountAmount,2)
          }
          if (documentDet.itemSuppPriceAmount) {
            updateSumObject.supplierNetoAmount += this.round(documentDet.itemSuppPriceAmount,2)
          }
          if (documentDet.itemBaseAmount) {
            updateSumObject.documentDescription9 += parseFloat(documentDet.itemBaseAmount)
          }
          if (documentDet.itemBaseAmountNoVAT) {
            updateSumObject.documentTotalAmountNetto += parseFloat(documentDet.itemBaseAmountNoVAT)
          }
          // if (documentDet.itemVAT1Amount) {
          //   updateSumObject.documentTotalAmountVAT += parseFloat(documentDet.itemVAT1Amount)
          // }
          //const dD1 = documentDet.itemDirectDuty1Amount ? parseFloat(documentDet.itemDirectDuty1Amount) : 0
          // if (documentDet.itemAmountWithVAT) {
          //   updateSumObject.documentTotalAmountBrutto += parseFloat(documentDet.itemAmountWithVAT) + dD1
          // }
          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat1) {
            updateSumObject.documentTotalVAT1Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT1Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT1Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat2) {
            updateSumObject.documentTotalVAT2Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT2Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT2Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat3) {
            updateSumObject.documentTotalVAT3Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT3Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT3Base += (parseFloat(documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (documentDet.itemBaseAmount) {
            if (parseInt(documentDet.FreeF1) === 1) {
              updateSumObject.FreeF1 += parseFloat(documentDet.itemBaseAmount)
            }
            if (parseInt(documentDet.FreeF1) === 2) {
              updateSumObject.FreeF2 += parseFloat(documentDet.itemBaseAmount)
              updateSumObject.FreeF5 += parseFloat(documentDet.empWrkHrs)
            }
            if (parseInt(documentDet.FreeF1) === 3) {
              updateSumObject.FreeF3 += parseFloat(documentDet.itemBaseAmount)
            }
          }
          if (documentDet.itemBaseAmountNoVAT) {
            if (this.round(parseFloat(documentDet.itemVAT1Amount),2) === 0) {
              updateSumObject.FreeF4 += parseFloat(documentDet.itemBaseAmountNoVAT)
            }
          }
          if (documentDet.itemDirectDuty1Amount) {
            updateSumObject.documentTotalAmountDirectD1+= parseFloat(documentDet.itemDirectDuty1Amount)
          }
        })
      }

      updateSumObject.documentTotalAmountNetto = updateSumObject.documentTotalAmountNetto ? this.round(updateSumObject.documentTotalAmountNetto, 2) : 0
      updateSumObject.documentTotalVAT1Amount  = this.round((updateSumObject.documentTotalVAT1Base * ( (hrVat1/100))),2)
      updateSumObject.documentTotalVAT2Amount  = this.round((updateSumObject.documentTotalVAT2Base * ( (hrVat2/100))),2)
      updateSumObject.documentTotalVAT3Amount  = this.round((updateSumObject.documentTotalVAT3Base * ( (hrVat3/100))),2)
      updateSumObject.documentDescription9 = updateSumObject.documentDescription9 ? this.round(updateSumObject.documentDescription9, 2) : 0
      updateSumObject.supplierNetoAmount = updateSumObject.supplierNetoAmount ? this.round(updateSumObject.supplierNetoAmount, 2) : 0
      updateSumObject.supplierMargin = this.round(updateSumObject.documentTotalAmountNetto - updateSumObject.supplierNetoAmount, 2)
      updateSumObject.documentTotalAmountVAT = updateSumObject.documentTotalVAT1Amount + updateSumObject.documentTotalVAT2Amount + updateSumObject.documentTotalVAT3Amount
      updateSumObject.documentTotalAmountBrutto = updateSumObject.documentTotalAmountNetto + updateSumObject.documentTotalAmountVAT
      updateSumObject.documentTotalVAT1Per = hrVat1 ? this.round(hrVat1, 2) : 0
      updateSumObject.documentTotalVAT2Per = hrVat2 ? this.round(hrVat2, 2) : 0
      updateSumObject.documentTotalVAT3Per = hrVat3 ? this.round(hrVat3, 2) : 0

      // updateSumObject.documentTotalVAT1Base = hrVat1 && updateSumObject.documentTotalVAT1Amount ? this.round(updateSumObject.documentTotalVAT1Amount / (hrVat1/100), 2) : 0
      // updateSumObject.documentTotalVAT2Base = hrVat2 && updateSumObject.documentTotalVAT2Amount ? this.round(updateSumObject.documentTotalVAT2Amount / (hrVat2/100), 2) : 0
      // updateSumObject.documentTotalVAT3Base = hrVat3 && updateSumObject.documentTotalVAT3Amount ? this.round(updateSumObject.documentTotalVAT3Amount / (hrVat3/100), 2) : 0
      updateSumObject.FreeF1 = updateSumObject.FreeF1 ? this.round(updateSumObject.FreeF1, 2) : 0
      updateSumObject.FreeF2 = updateSumObject.FreeF2 ? this.round(updateSumObject.FreeF2, 2) : 0
      updateSumObject.FreeF3 = updateSumObject.FreeF3 ? this.round(updateSumObject.FreeF3, 2) : 0
      updateSumObject.FreeF4 = updateSumObject.FreeF4 ? this.round(updateSumObject.FreeF4, 2) : 0
      updateSumObject.FreeF5 = updateSumObject.FreeF5 ? this.round(updateSumObject.FreeF5, 2) : 0
      updateSumObject.documentDescription10 = updateSumObject.documentDescription9 - updateSumObject.documentTotalAmountNetto
      updateSumObject.documentTotalAmountPayInAdvance = updateSumObject.documentTotalAmountPayInAdvance ? this.round(updateSumObject.documentTotalAmountPayInAdvance, 2) : 0
      updateSumObject.documentTotalAmountToPay = updateSumObject.documentTotalAmountBrutto ? (this.round(updateSumObject.documentTotalAmountBrutto, 2) - (updateSumObject.documentTotalAmountPayInAdvance )): 0

      updateSumObject.documentTotalAmountNettoForeign = updateSumObject.documentTotalAmountNetto ? this.round((updateSumObject.documentTotalAmountNetto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountVATForeign = updateSumObject.documentTotalAmountVAT ? this.round((updateSumObject.documentTotalAmountVAT / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountBruttoForeign = updateSumObject.documentTotalAmountBrutto ? this.round((updateSumObject.documentTotalAmountBrutto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountPayInAdvanceForeign = this.round((updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate), 2)
      updateSumObject.documentTotalAmountToPayForeign = updateSumObject.documentTotalAmountBrutto ? (this.round((updateSumObject.documentTotalAmountBrutto/ this.ExRate), 2) - (updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate) ) : 0
      updateSumObject.documentTotalAmountDirectD1Fore = updateSumObject.documentTotalAmountDirectD1 ? this.round((updateSumObject.documentTotalAmountDirectD1 / this.ExRate), 2) : 0

      const newHead = {...this.$store.state.documentActivHead, ...updateSumObject}
      if (newHead) {
          this.$store.dispatch('setDocumentActivHead', newHead)
        } else {
          this.$store.dispatch('setDocumentActivHead', {})
        }
    },
    async setNewItemID(itemID) {
      const emObj = {}
      this.mainQuery2 = {...emObj}
      this.mainQuery2.CompanyId = this.$store.state.companyid
      this.mainQuery2.itemID = itemID
      console.log('setNewItemID itemID: ', itemID);
      if (this.$store.state.editItem === 0 ) {
        this.itemsLoc = (await ItemService.index(this.mainQuery2)).data.items
        this.findIt()
      }
      if (this.$store.state.editItem === 1 ) {
        // ako vec nesto imam upisano onda samo odabrem sifru, NE radim overwrite ostalog
        if (this.iName.length > 0 && parseNum(this.iFullTotal,2) !== 0) {
          console.log('1 ... trazim bazicno', this.mainQuery2)
          this.findItBasic(this.mainQuery2)
        }
        // // nemam nista upisano pa ga odabrem iz sifrarnika
        if (this.iName.length === 0 && parseNum(this.iFullTotal,2) === 0) {
          if (this.selectIL.itemID && this.selectIL.itemID !== this.$store.state.selectedItemId) {
            console.log('trazim full')
            this.findIt()
          }
        }
      }
      //this.$store.dispatch('setSelectedItemId', itemID)
    },
    async newFromStore() {
      const data = this.$store.state.selectedItemId
      this.iID = data.itemID
      this.iGroup = data.GroupId  ? data.GroupId : ''
      this.iGroupName = data.GroupName ? data.GroupName : ''
      this.iUnit = data.Unit ? data.Unit : ''
      this.documentDet.itemID = data.itemID
      this.documentDet.itemGroup = this.iGroup
      this.documentDet.itemGroupName = this.iGroupName
      this.documentDet.itemUnit = this.iUnit
      this.haveItemSelected = true
      this.itemsLoc = (await ItemService.index(this.mainQuery2)).data.items
    }
  },
  watch: {
    'selectIL' () {
      console.log('1.1 WATCH selectIL', this.selectIL, ' da li mijenjam ', this.radimEdit, ' da li radimNovi ', this.radimEdit)
      if (this.selectIL && Object.keys(this.selectIL).length > 0  && this.radimEdit === false && this.radimNovi === false) {
        console.log('1.2 WATCH UNUTRA SAM setiram ItemID', this.selectIL)
        this.setNewItemID(this.selectIL.itemID)
      }
      if (!this.selectIL) {
        this.clearIt()
      }
      this.radimNovi = false
    },
    'mySelectedItemId' () {
      console.log('2.1 WATCH mySelectedItemId  this.$store.state.selectedItemId', this.$store.state.selectedItemId)
      if (this.$store.state.selectedItemId) {
        console.log('2.2 WATCH imam nesto odabrano ', this.$store.state.selectedItemId, this.selectIL )
        const emObj = {}
        this.mainQuery2 = {...emObj}
        this.mainQuery2.CompanyId = this.$store.state.companyid
        this.mainQuery2.itemID = this.$store.state.selectedItemId
        this.componentKey += 1
        this.selectIL =
        {
          itemByID: (this.$store.state.selectedItemId.itemID + ' ' + this.$store.state.selectedItemId.itemName),
          itemID: this.$store.state.selectedItemId.itemID,
          key : this.componentKey
        }
        this.newFromStore()
         
        console.log('2.3 WATCH imam nesto odabrano this.selectIL ', this.selectIL )
        this.radimNovi = true
        this.$store.dispatch('setSelectedItemId', null)
        
      }
     // this.partner()
    },
    'iPrice' () {
      if (this.workOn === true) {
      
        if (!this.iPrice) {
          this.iPrice = 0
        }        
        if (!this.doRetail) {
          this.iPrice = this.round(this.iPrice,3)
          this.inputDocCalc()
        }
        // if (!this.fullpriceChange && this.$store.state.documentActiv === 'ReceiptPurchase') {
        //   this.iPrice = this.round(this.iPrice,2)
        //   this.calculateDiscount()
        //   console.log('iPrice 2 ')
        // }
      }
    },
    'iForePrice' () {
      if (this.workOn === true) {        
        if (!this.iForePrice) {
          this.iForePrice = 0
        }             
        if (!this.doRetail && this.exportDoc && this.$store.state.documentActiv !== 'ReceiptPurchase') {
          this.iForePrice = this.round(this.iForePrice,2)
          this.inputDocCalc()
        }
      }
    },
    'iDiscountPercentage1' () {
      if (this.workOn === true) {
        if (!this.iDiscountPercentage1) {
          this.iDiscountPercentage1 = 0
        }
          
          if (this.iDiscountPercentage1 > 99.99){
            this.iDiscountPercentage1 = 0
          }
          if (this.iDiscountPercentage1 < 0){
            this.iDiscountPercentage1 = 0
          }
          this.inputDocCalc()
          // if (this.fullpriceChange) {
          //    if (this.$store.state.companyActiv.CompanyUseRetailPrice === true) {
          //     if (this.exportDoc === false) {
          //       this.calculateDiscount()
          //     }
          //     if (this.exportDoc === true) {
          //         this.calculateDiscountFore()
          //     }
          //    }
          //    if (this.$store.state.companyActiv.CompanyUseRetailPrice === false) {
          //       if (this.exportDoc === false) {
          //         this.calculatePrice()
          //       }
          //       if (this.exportDoc === true) {
          //         this.calculateDiscountFore()
          //       }
          //    }
          // }
      }
    },
    'iPcsPlus' () {
      if (!this.iPcsPlus) {
        this.iPcsPlus = 1
      }
      this.iPcsPlus = this.round(this.iPcsPlus, 3)
      this.inputDocCalc()
      // this.initPcs()
      // this.initCalc()
    },

    'iPcsMinus' () {
      if (!this.iPcsMinus) {
        this.iPcsMinus = 1
      }
      this.iPcsMinus = this.round(this.iPcsMinus, 3)
      this.inputDocCalc()
      // this.initPcs()
      // this.initCalc()
    },

    'iPcsNeutral' () {
      if (!this.iPcsNeutral) {
        this.iPcsNeutral = 1
      }
      this.iPcsNeutral = this.round(this.iPcsNeutral, 3)
      this.inputDocCalc()
      // this.initPcs()
      // this.initCalc()
    },

    'iVAT1Percentage' () {
      if (this.workOn === true) {
        if (!this.iVAT1Percentage) {
          this.iVAT1Percentage = 25
        }
        this.inputDocCalc()
        // if (this.fullpriceChange === true && !this.exportDoc) {
        //   this.calculateDiscount()
        // }
      }
    },
    'iDirectDuty1' () {
      if (this.workOn === true) {
        if (!this.iDirectDuty1) {
          this.iDirectDuty1 = 0
        }
        this.inputDocCalc()
        // if (this.fullpriceChange === true && !this.exportDoc) {
        //   this.calculateDiscount()
        // }
      }
    },
    'iSuppBasePrice' () {
      if (!this.iSuppBasePrice) {
        this.iSuppBasePrice = 0
      }
      if (this.workOn === true) {
       // this.inputDocCalc()
        if (this.fullpriceChange === true) {
           this.initPcs()
          this.initSupp()
          this.marginFromRight()
          // this.initSupp()
          // this.calculateSupp()
          // this.calculatePrice()
          // this.calculateDiscount()
        }
      }
    },
    'iSuppBaseForePrice' () {
      if (!this.iSuppBaseForePrice) {
        this.iSuppBaseForePrice = 0
      }
      if (this.workOn === true) {
       // this.inputDocCalc()
        if (this.fullpriceChange === true) {
          this.initPcs()
          this.initSupp()
          this.marginFromRight()
          // this.initSupp()
          // this.calculateSupp()
          // this.calculatePrice()
          // this.calculateDiscount()
        }
      }
    },
    'iSuppDiscount' () {
      if (this.workOn === true) {
        if (!this.iSuppDiscount) {
          this.iSuppDiscount = 0
        }
        if (this.iSuppDiscount > 99.99){
            this.iSuppDiscount = 0
        }
       // this.inputDocCalc()
        if (this.fullpriceChange === true) {
          this.initPcs()
          this.initSupp()
          this.marginFromRight()
          // this.calculateSupp()
          // this.calculatePrice()
          // this.calculateDiscount()
        }
      }
    },
    'iMargin' () {
      if (this.workOn === true) {
        if (!this.iMargin){
          this.iMargin = 0
        }
        if (parseNum(this.iMargin) === 0) {
          this.marginIsZero = true
        }
        this.inputDocCalc()
      }
      // if (this.fullpriceChange) {
      //  if (this.$store.state.documentSide === 1) {
      //     if (this.$store.state.documentActiv === 'ReceiptPurchase') {
      //       this.initSupp()
      //       this.calculateSupp()
      //       this.calculatePrice()
      //       this.calculateDiscount()
      //       this.maxDiscPer = (this.iAmountWithVAT / 100) ? this.round((this.iAmountWithVAT / 100),3) : 0
      //       this.iMaxDiscount = ((this.iMarginAmount / this.maxDiscPer)) ? this.round(((this.iMarginAmount / this.maxDiscPer)),2) : 0
      //     }
      //   }
      // }
    },
    'iPriceWithVAT' () {
      if (!this.iPriceWithVAT){
        this.iPriceWithVAT = 0
      }
       if (!this.fullpriceChange && !this.exportDoc) {
         this.inputDocCalc()
         //this.calculatePrice()
       }
       if (this.fullpriceChange && this.doRetail) {
         this.iFullPriceOriginal = this.iPriceWithVAT
         this.inputDocCalc()
       }
      
    //  if (this.workOn === true) {
        // this.documentDet.itemMarginAmount = this.documentDet.itemBaseAmountNoVAT - this.itemSuppPriceAmount
        // if (this.pcsLoc !== 0) {
        //   this.maxDiscPer = (this.documentDet.itemPriceWithVAT / 100) ? this.round((this.documentDet.itemPriceWithVAT / 100),3) : 0
        //   this.documentDet.itemMaxDiscount = (100 - (this.documentDet.itemMarginAmount / this.maxDiscPer)) ? this.round((100 - (this.documentDet.itemMarginAmount / this.maxDiscPer)),2) : 0
        // }
        // this.documentDet.itemMargin = 0
        // this.documentDet.FreeF2 = 0
        // if (this.documentDet.itemSuppPriceAmount !== 0) {
        //   this.documentDet.itemMargin = (this.documentDet.itemMarginAmount / (this.documentDet.itemSuppPriceAmount / 100)) ? this.round((this.documentDet.itemMarginAmount / (this.documentDet.itemSuppPriceAmount / 100)),2) : 0
        // }
        // if (this.pcsLoc !== 0) {
        //   this.documentDet.FreeF2 = (this.documentDet.itemMarginAmount / this.pcsLoc) ? this.round((this.documentDet.itemMarginAmount / this.pcsLoc),2) : 0
        // }
        
     // }
    },
    'iForePriceWithVAT' () {
      if (!this.iForePriceWithVAT){
        this.iForePriceWithVAT = 0
      }
       if (!this.fullpriceChange && this.exportDoc ) {
         this.inputDocCalc()
         //this.calculatePrice()
       }
       if (this.fullpriceChange && this.doRetail) {
         this.iFullPriceOriginal = this.iPriceWithVAT
         this.inputDocCalc()
       }

    },
    // 'selectIL.itemID' () {
    //   if (this.workOn === true) {
    //     if (!this.selectIL) {
    //       this.haveItemSelected = false
    //       this.newItem = true
    //       this.firstUpdate = 3
    //       this.clearIt()
    //     } else {
    //       if (this.selectIL && this.selectIL.itemID) {
    //         this.haveItemSelected = true
    //         this.findItem()
    //       } else {
    //         this.clearIt()
    //       }
    //     }
    //   }
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-text-field {
        margin: 0;
        padding: 0;
    }

/* RUC i RUC% ispod dobavne cijene.
 *
 * Sitno i blijedo, bez naziva: tko radi na stavci zna sto je, a tko stoji iza
 * leda ne procita s udaljenosti. Naziv je u "title" atributu, na prijelaz
 * misem. Ne koristiti bold ni boju - time bi postalo uocljivo. */
/* Zadnja dva polja u kartici "Cijena" izlaznih dokumenata.
 *
 * PDV % dobiva tocno onoliko sirine koliko treba za naziv i dva broja, a sve
 * sto ostane do kraja reda uzima "Ukupno". Mreza od 12 stupaca to ne moze -
 * jedan stupac (~50px) je preuzak da se procita naziv, dva (~105px) su
 * nepotrebno siroka. Vrijedi od "sm" navise; na mobitelu polja ionako idu
 * jedno ispod drugog. */
@media (min-width: 600px) {
  .pdv-usko {
    flex: 0 0 100px;
    max-width: 100px;
  }
  /* Osnova mora biti 0, ne "auto": uz "auto" se racuna prema sadrzaju polja,
     sto je sire od ostatka reda, pa "Ukupno" padne u novi red i rastegne se
     preko cijele kartice. */
  .ukupno-ostatak {
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
  }
}

.ruc-tiho {
  font-size: 10px;
  line-height: 12px;
  color: #c4c4c4;
  padding: 2px 0 0 12px;
  white-space: nowrap;
}

/* Polja koja program racuna.
 *
 * Ne oznacavaju se posebno - prepoznaju se po tome sto su onemogucena, a to
 * vec jesu: cijena s rabatom, iznos marze, osnovica, PDV, bruto. Siva podloga
 * i isprekidani okvir odmah kazu gdje nema smisla tipkati.
 *
 * Vrijedi samo unutar ovog ekrana ("stavka-unos"), da se ostali obrasci ne
 * mijenjaju usput.
 */
.stavka-unos .v-input--is-disabled .v-input__slot {
  background: #f7f9fb;
}
.stavka-unos .v-input--is-disabled fieldset {
  border-style: dashed;
  border-color: #b0bec5;
}
/* Iznos u onemogucenom polju mora ostati citljiv - to je podatak, ne siva
   nedostupna kontrola. */
.stavka-unos .v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.82) !important;
}
.stavka-unos .v-input--is-disabled .v-label {
  color: #78909c !important;
}

/* "redak", a ne "red" - "red" je Vuetifyjeva klasa za crvenu boju i
   obojila bi cijeli popis.
   Izracun je popis, ne niz polja: oznaka lijevo, iznos desno, zbroj na kraju.
   Onemogucena polja su se citala teze nego obican tekst, a zauzimala su vise
   mjesta. */
.stavka-unos .racun-stavke {
  padding-top: 6px;
  padding-bottom: 10px;
  /* Dva stupca, ne jedan dugi popis - u jednom stupcu je izgledalo kao
     blagajnicki isjecak i nepotrebno se rastezalo u visinu. */
  display: grid;
  /* Dva stupca kad ima mjesta, inace jedan. Najduza oznaka
     ("Direktna nak. ukupno") s iznosom stane u 190px. */
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  column-gap: 20px;
}
.stavka-unos .racun-stavke .redak {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 6px 2px;
  border-bottom: 1px dotted #e0e6ea;
}
.stavka-unos .racun-stavke .redak span {
  color: #607d8b;
  font-size: 13px;
}
.stavka-unos .racun-stavke .redak b {
  margin-left: auto;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}
.stavka-unos .racun-stavke .redak.zbroj {
  /* Zbroj ide preko oba stupca, da se ne izgubi u mrezi. */
  grid-column: 1 / -1;
  border-bottom: 0;
  border-top: 2px solid #1976d2;
  margin-top: 6px;
  padding-top: 9px;
}
.stavka-unos .racun-stavke .redak.zbroj span {
  color: #1565c0;
  font-weight: 700;
}
.stavka-unos .racun-stavke .redak.zbroj b {
  font-size: 20px;
  color: #1565c0;
}
/* Naslov kartice ide od ruba do ruba, kao na kartici Izracun.
   Kartice Artikl/Cijena/eRacun imaju "pa-2", pa bi im naslov inace visio
   8px unutar okvira i traka ne bi bila poravnata s ostalima. */
.stavka-unos .v-card.pa-2 > .naslov-kartice {
  margin: -8px -8px 0 -8px;
}

/* Sazetak eRacuna je dug koliko i kategorija PDV-a plus KPD sifra i nije
   stajao u karticu - zadnje slovo je izlazilo izvan okvira. Gumb se sada
   smije stisnuti, a visak teksta zavrsava trotockom; cijeli tekst je u
   "title" pa se vidi na prelazak misem. */
.stavka-unos .sazetak-gumb {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}
.stavka-unos .sazetak-gumb .v-btn__content {
  max-width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
}
.stavka-unos .sazetak-gumb .sazetak {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stavka-unos .naslov-kartice .dodatak {
  font-weight: 400;
  font-size: 12px;
  color: #6b8299;
  margin-left: 8px;
}

/* Brojke se citaju desno poravnate i u stupcu. */
.stavka-unos input[type="number"] {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
</style>
